import { jsx as p, jsxs as O, Fragment as an } from "react/jsx-runtime";
import { GOOGLE_MAPS_LIBRARIES as vr, GOOGLE_MAPS_LOADER_ID as Ar, GOOGLE_MAPS_MAP_ID as Cr } from "../config/googleMaps.js";
import { useJsApiLoader as Lr } from "@react-google-maps/api";
import Kn from "lodash/debounce";
import Pn, { useState as Pt, useMemo as me, memo as Ir, useRef as Mt, useCallback as wt, useEffect as fe } from "react";
import Or from "../components/organisms/ReactMap/index.js";
import { useMapContext as Mr } from "../components/organisms/ReactMap/MapContext.js";
import { TRANSFORM_UPDATE_DEBOUNCE as Sr, MAP_PINS_UPDATE_DEBOUNCE as Tr, DEFAULT_OVERLAY_OPACITY as Dr, MAP_CONTROL_SIZE as Rr, MAP_TYPE_CHANGE_DEBOUNCE as Er } from "../components/organisms/OverlayMap/constants.js";
import Fr from "../components/organisms/OverlayMap/controls/MiniControls.js";
import { c as _e } from "react/compiler-runtime";
import { FilledInput as $r, Input as kr, OutlinedInput as Ur, InputAdornment as Vr, IconButton as de, Box as St, Paper as jn, Alert as zr, useTheme as Br, ToggleButton as Jt, Tooltip as yt, MenuItem as gi, Typography as Sn, ToggleButtonGroup as _i, Menu as Wr, DialogTitle as Hr, Button as Jn, DialogContent as Yr, DialogActions as Xr, Dialog as Gr } from "@mui/material";
import qr from "@mui/icons-material/RestartAlt";
import Kr from "@mui/icons-material/Fullscreen";
import Jr from "@mui/icons-material/FullscreenExit";
import { controlBarStyles as U, dialogStyles as dn, mapContainerStyles as Pi, iconStyles as Zr } from "../components/organisms/OverlayMap/styles.js";
import { Warning as Qr, InfoRounded as jr, ChevronLeft as to, ChevronRight as eo, Upload as no } from "@mui/icons-material";
import xi from "@mui/icons-material/Opacity";
import io from "@mui/icons-material/Satellite";
import wi from "@mui/icons-material/Layers";
import ro from "@mui/icons-material/SignalCellularAlt";
import oo from "@mui/icons-material/Router";
import ao from "@mui/icons-material/Edit";
import lo from "@mui/icons-material/DeleteOutlineRounded";
import so from "@mui/icons-material/UploadFile";
import Wi from "@mui/icons-material/ArrowDropDown";
import nn from "@mui/icons-material/Add";
import co from "@mui/icons-material/Download";
import uo from "@mui/icons-material/Map";
import fo from "@mui/icons-material/SatelliteAlt";
import { theme as he } from "../styles/theme.js";
import "../components/atoms/FormControl/FormControl.js";
import "../components/atoms/FormControlLabel/FormControlLabel.js";
import "./index.esm.js";
import "react-dom/server";
import '../assets/FilterWrapper.css';import '../assets/map.css';import '../assets/Map2.css';/* empty css     */
import { Grid as ot } from "../components/atoms/Grid/Grid.js";
import "../components/atoms/Paper/Paper.js";
import "../components/atoms/Box/Box.js";
import "../components/atoms/Radio/Radio.js";
import "../components/atoms/RadioGroup/RadioGroup.js";
import po from "@mui/icons-material/Visibility";
import mo from "@mui/icons-material/VisibilityOff";
import "../components/atoms/Menu/Menu.js";
import "../components/atoms/MenuItem/MenuItem.js";
import { Typography as Lt } from "../components/atoms/Typography/Typography.js";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Warning";
import "@mui/material/styles";
import "../components/atoms/Table/Table.js";
import "../components/atoms/TableBody/TableBody.js";
import "../components/atoms/TableHead/TableHead.js";
import "../components/atoms/TableRow/TableRow.js";
import "../components/atoms/TableCell/TableCell.js";
import "../components/atoms/ToggleButton/ToggleButton.js";
import "../components/atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import ho from "@mui/icons-material/ExpandMore";
import "../components/atoms/Stepper/Stepper.js";
import "../components/atoms/Step/Step.js";
import "../components/atoms/StepLabel/StepLabel.js";
import "../components/atoms/Link/Link.js";
import "../components/atoms/LoadingButton/LoadingButton.js";
import "../components/atoms/LinearProgress/LinearProgress.js";
import "../components/atoms/Stack/Stack.js";
import "../components/atoms/Card/Card.js";
import "../components/atoms/CardActions/CardActions.js";
import { FormHelperText as go } from "../components/atoms/FormHelperText/FormHelperText.js";
import "../components/atoms/AccordionDetails/AccordionDetails.js";
import "../components/atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/icons-material/Close";
import "@mui/material/Typography";
import "@mui/material/Dialog";
import _o from "@mui/icons-material/InfoOutlined";
import Po from "@mui/icons-material/ArrowDropUp";
import xo from "@mui/icons-material/ArrowLeft";
import wo from "@mui/icons-material/ArrowRight";
import yo from "highcharts-react-official";
import No from "highcharts";
import ti from "moment-timezone";
import "highcharts/highcharts";
import "../components/molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import { Chip as bo } from "../components/atoms/Chip/Chip.js";
import { Skeleton as He } from "../components/atoms/SkeletonLoader/SkeletonLoader.js";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../components/molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
/* empty css              */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/Search";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import { Button as vo } from "../components/atoms/Button/Button.js";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/Info";
import "@mui/icons-material/Build";
import "./ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../components/organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "@mui/icons-material/ArrowForward";
import { DeletePlanDialog as Ao } from "../components/organisms/OverlayMap/dialogs/DeletePlanDialog.js";
import { ResetDialog as Co } from "../components/organisms/OverlayMap/dialogs/ResetDialog.js";
import { getFileSizeString as yi, createFileChangeHandler as Lo } from "../components/organisms/OverlayMap/utils/uploadUtils.js";
import { FormLabel as Io } from "../components/atoms/FormLabel/FormLabel.js";
import "../components/organisms/RadarGraph/RadarGraph.js";
import "@mui/material/Button";
import "../components/organisms/ReactMap/GMapStatic.js";
import "../components/organisms/ReactMap/hooks.js";
import "@mui/icons-material/Clear";
import "./TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../components/organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "../components/organisms/ScoreGauge/ScoreGauge.js";
import "../components/organisms/SunburstGraph/SunburstGraph.js";
import "@mui/icons-material/Menu";
import "../fetch/fetchConfig.js";
import "immer";
import { useUploadDialog as Oo } from "../components/organisms/OverlayMap/hooks/useUploadDialog.js";
import { OverlayWrapper as Mo } from "../components/organisms/OverlayMap/OverlayWrapper.js";
import { c as mn, a as Tn, b as Ni, d as So, O as bi } from "./mapUtils.js";
import { getPlanIconComponent as To, getPlanIconsAndTooltips as Hi } from "../components/organisms/OverlayMap/utils/planIconsUtils.js";
import { SimpleTreeView as Do } from "@mui/x-tree-view";
import Ro from "@mui/icons-material/ChevronRight";
import Eo from "../components/molecules/Tree/IconExpansionTreeItem.js";
import { updateURL as Yi } from "../utilities/url.js";
import { Tooltip as si } from "../components/atoms/Tooltip/Tooltip.js";
import { AnimationCounter as Fo } from "../components/atoms/Counter/AnimationCounter.js";
import { formatCompactNumber as $o, getFormattedBytes as ko, formatNumber as Uo } from "../utilities/index.js";
import { CopyComponent as Vo } from "../components/atoms/CopyComponent/CopyComponent.js";
import { LegendMarker as vi } from "../components/atoms/LegendMarker/LegendMarker.js";
import { styles as Be } from "../components/molecules/Widgets/WidgetStatusText/WidgetStatusText.styles.js";
import { styles as Ln } from "../components/molecules/Widgets/WidgetMetricGraph/WidgetMetricGraph.styles.js";
import zo from "../utilities/safeDownload.js";
function Bo(e) {
  const t = _e(48);
  let n, i, r, o, a, s, l, u, f, P, _;
  t[0] !== e ? ({
    variant: l,
    width: _,
    type: u,
    height: r,
    size: f,
    sx: s,
    label: o,
    required: P,
    error: n,
    errorText: i,
    ...a
  } = e, t[0] = e, t[1] = n, t[2] = i, t[3] = r, t[4] = o, t[5] = a, t[6] = s, t[7] = l, t[8] = u, t[9] = f, t[10] = P, t[11] = _) : (n = t[1], i = t[2], r = t[3], o = t[4], a = t[5], s = t[6], l = t[7], u = t[8], f = t[9], P = t[10], _ = t[11]);
  const m = l === void 0 ? "outlined" : l, y = u === void 0 ? "text" : u, w = f === void 0 ? "small" : f, g = P === void 0 ? !1 : P, [N, V] = Pt(!1);
  let L, A;
  t[12] !== a ? ({
    endAdornment: L,
    ...A
  } = a, t[12] = a, t[13] = L, t[14] = A) : (L = t[13], A = t[14]);
  let T;
  t[15] !== N ? (T = () => {
    V(!N);
  }, t[15] = N, t[16] = T) : T = t[16];
  const z = T, J = Wo, F = m === "filled" ? $r : m === "standard" ? kr : Ur, Z = w === "medium" ? "40px" : "32px", H = !!a.multiline, $ = r ?? Z;
  let q;
  t[17] !== H || t[18] !== $ ? (q = H ? {
    minHeight: $,
    height: "auto",
    alignItems: "flex-start",
    "& .MuiInputBase-inputMultiline": {
      boxSizing: "border-box",
      minHeight: $
    }
  } : {
    height: $
  }, t[17] = H, t[18] = $, t[19] = q) : q = t[19];
  let Q;
  t[20] !== q || t[21] !== _ ? (Q = {
    width: _,
    ...q
  }, t[20] = q, t[21] = _, t[22] = Q) : Q = t[22];
  const S = Q;
  let Y;
  t[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100%"
  }, t[23] = Y) : Y = t[23];
  let nt;
  t[24] !== o || t[25] !== g ? (nt = o && /* @__PURE__ */ O(Io, { sx: Ho, children: [
    o,
    g && /* @__PURE__ */ p(St, { component: "span", sx: Yo, children: " *" })
  ] }), t[24] = o, t[25] = g, t[26] = nt) : nt = t[26];
  let mt;
  t[27] !== F || t[28] !== S || t[29] !== L || t[30] !== n || t[31] !== z || t[32] !== A || t[33] !== a || t[34] !== g || t[35] !== N || t[36] !== w || t[37] !== s || t[38] !== y || t[39] !== m ? (mt = y === "password" ? /* @__PURE__ */ p(F, { id: "outlined-adornment-password", type: N ? "text" : "password", error: n, required: g, size: w, endAdornment: /* @__PURE__ */ O(Vr, { position: "end", children: [
    L || null,
    /* @__PURE__ */ p(de, { "aria-label": "toggle password visibility", onClick: z, onMouseDown: J, sx: {
      p: 0.5,
      mr: "15px"
    }, children: N ? /* @__PURE__ */ p(po, {}) : /* @__PURE__ */ p(mo, {}) })
  ] }), sx: [S, Ai[m], ...Array.isArray(s) ? s : [s]], placeholder: A.placeholder ? A.placeholder : "", ...A }) : /* @__PURE__ */ p(F, { sx: [S, Ai[m], ...Array.isArray(s) ? s : [s]], error: n, required: g, size: w, type: y, ...a }), t[27] = F, t[28] = S, t[29] = L, t[30] = n, t[31] = z, t[32] = A, t[33] = a, t[34] = g, t[35] = N, t[36] = w, t[37] = s, t[38] = y, t[39] = m, t[40] = mt) : mt = t[40];
  let at;
  t[41] !== n || t[42] !== i ? (at = n && i && /* @__PURE__ */ p(go, { sx: Xo, children: i }), t[41] = n, t[42] = i, t[43] = at) : at = t[43];
  let xt;
  return t[44] !== at || t[45] !== nt || t[46] !== mt ? (xt = /* @__PURE__ */ O(St, { sx: Y, children: [
    nt,
    mt,
    at
  ] }), t[44] = at, t[45] = nt, t[46] = mt, t[47] = xt) : xt = t[47], xt;
}
function Wo(e) {
  e.preventDefault();
}
const Ai = {
  outlined: (e) => ({
    border: `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`,
    backgroundColor: e.palette.background.paper,
    borderRadius: "8px",
    color: "#5B5B5B",
    fontSize: "12px",
    "& .MuiInputBase-input": {
      padding: "6px 16px",
      lineHeight: "20px"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&.Mui-focused": {
      borderColor: e.palette.primary.main,
      borderWidth: "1px"
    }
  }),
  filled: (e) => ({
    border: `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`,
    borderRadius: "8px",
    color: "#5B5B5B",
    backgroundColor: e.palette.action.hover,
    "&:before, &:after": {
      borderBottom: "none !important"
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottom: "none"
    },
    "& .MuiInputBase-input": {
      padding: "6px 16px",
      lineHeight: "20px",
      fontSize: "12px"
    },
    "&.Mui-focused": {
      borderColor: e.palette.primary.main,
      borderWidth: "1px"
    }
  }),
  standard: (e) => ({
    border: `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`,
    borderRadius: "8px",
    color: "#5B5B5B",
    "label + &": {
      marginTop: 0
    },
    "&:before, &:after": {
      borderBottom: "none !important"
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottom: "none"
    },
    "& .MuiInputBase-input": {
      padding: "6px 16px",
      lineHeight: "20px",
      fontSize: "12px"
    },
    "&.Mui-focused": {
      borderColor: e.palette.primary.main,
      borderWidth: "1px"
    }
  })
}, Ho = {
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  color: "#5A5A5A"
}, Yo = {
  color: "#d32f2f"
}, Xo = {
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "14px",
  color: "#d32f2f"
};
function Go(e) {
  const t = _e(9), {
    title: n,
    tooltip: i,
    TooltipIcon: r,
    key: o,
    children: a,
    gap: s
  } = e, l = s === void 0 ? 2 : s;
  let u;
  t[0] !== r || t[1] !== n || t[2] !== i ? (u = (n || i) && /* @__PURE__ */ O(ot, { container: !0, alignItems: "center", flexWrap: "nowrap", gap: 2, children: [
    n && /* @__PURE__ */ p(Lt, { type: "bodyText2", sx: {
      color: qo,
      ...Ko.titleText
    }, children: n }),
    i && /* @__PURE__ */ p(si, { title: i, children: r ? /* @__PURE__ */ p(r, {}) : /* @__PURE__ */ p(_o, { fontSize: "small", color: "disabled" }) })
  ] }), t[0] = r, t[1] = n, t[2] = i, t[3] = u) : u = t[3];
  let f;
  return t[4] !== a || t[5] !== l || t[6] !== o || t[7] !== u ? (f = /* @__PURE__ */ O(ot, { container: !0, direction: "column", gap: l, flexWrap: "nowrap", children: [
    u,
    a
  ] }, o), t[4] = a, t[5] = l, t[6] = o, t[7] = u, t[8] = f) : f = t[8], f;
}
function qo(e) {
  return e.vars?.palette.grey[600] ?? e.palette.grey[600];
}
const Ko = {
  titleText: {
    textWrap: "nowrap"
  }
};
function Jo(e) {
  const t = _e(15), {
    changePercentage: n,
    ChangeIcon: i,
    tooltip: r,
    TooltipIcon: o,
    title: a,
    subtext: s,
    value: l,
    unit: u,
    widgetImage: f,
    loading: P
  } = e, _ = P === void 0 ? !1 : P;
  let m = he.vars?.palette.grey[600] ?? he.palette.grey[600], y = jo;
  n && (n > 0 ? (m = he.vars?.palette.primary.main, y = Qo) : n < 0 && (m = he.vars?.palette.error.main ?? he.palette.error.main, y = Zo));
  let w;
  t[0] !== i || t[1] !== y || t[2] !== m || t[3] !== n || t[4] !== _ || t[5] !== s || t[6] !== u || t[7] !== l || t[8] !== f ? (w = _ ? /* @__PURE__ */ O(an, { children: [
    /* @__PURE__ */ O(ot, { container: !0, alignItems: "center", gap: 2, children: [
      f,
      /* @__PURE__ */ p(He, { variant: "rounded", width: 148, height: 38 })
    ] }),
    s && /* @__PURE__ */ p(He, { variant: "rounded", width: "80%", height: 16 })
  ] }) : /* @__PURE__ */ O(ot, { container: !0, flexDirection: "column", gap: 1, children: [
    /* @__PURE__ */ O(ot, { container: !0, alignItems: "center", gap: 2, wrap: "nowrap", children: [
      f,
      /* @__PURE__ */ O(Lt, { type: "statistics1", sx: Ci.statisticsText, children: [
        l === 0 ? l : /* @__PURE__ */ p(Fo, { value: l }),
        u
      ] }),
      n !== void 0 && /* @__PURE__ */ O(ot, { container: !0, width: "fit-content", height: "fit-content", gap: 0.5, marginLeft: 1, alignItems: "center", flexWrap: "nowrap", bgcolor: `${m}26`, borderRadius: 1.5, paddingX: 1, paddingY: 0.25, children: [
        i ? /* @__PURE__ */ p(i, {}) : /* @__PURE__ */ p(y, {}),
        /* @__PURE__ */ p(Lt, { type: "bodyText1", color: m, children: `${$o(n, !0)}%` })
      ] })
    ] }),
    s && /* @__PURE__ */ p(Lt, { type: "bodyText3", sx: Ci.subtext, children: s })
  ] }), t[0] = i, t[1] = y, t[2] = m, t[3] = n, t[4] = _, t[5] = s, t[6] = u, t[7] = l, t[8] = f, t[9] = w) : w = t[9];
  let g;
  return t[10] !== o || t[11] !== w || t[12] !== a || t[13] !== r ? (g = /* @__PURE__ */ p(Go, { title: a, tooltip: r, TooltipIcon: o, children: w }), t[10] = o, t[11] = w, t[12] = a, t[13] = r, t[14] = g) : g = t[14], g;
}
function Zo() {
  return /* @__PURE__ */ p(Wi, { style: {
    color: he.vars?.palette.error.dark ?? he.palette.error.dark
  } });
}
function Qo() {
  return /* @__PURE__ */ p(Po, { style: {
    color: he.vars?.palette.primary.main ?? he.palette.primary.main
  } });
}
function jo() {
  return /* @__PURE__ */ O(ot, { container: !0, flexWrap: "nowrap", sx: {
    rotate: "90deg"
  }, children: [
    /* @__PURE__ */ p(xo, { color: "action" }),
    /* @__PURE__ */ p(wo, { color: "action", style: {
      marginLeft: -14
    } })
  ] });
}
const Ci = {
  statisticsText: {
    textWrap: "nowrap"
  },
  subtext: {
    opacity: 0.7
  }
};
function ta(e) {
  const t = _e(31), {
    title: n,
    content: i,
    loading: r,
    gap: o,
    contentTypography: a,
    width: s
  } = e;
  let l, u, f, P, _, m, y, w, g, N;
  if (t[0] !== i || t[1] !== r || t[2] !== o || t[3] !== a || t[4] !== s || t[5] !== n) {
    const A = i === void 0 ? [] : i, T = r === void 0 ? !1 : r, z = o === void 0 ? 1 : o, J = a === void 0 ? "bodyText2" : a, F = s === void 0 ? "100%" : s, Z = {
      color: "grey",
      size: "md",
      variant: "disc"
    };
    u = ot, N = !0, f = Be.container, P = z, _ = F, t[16] !== n ? (m = /* @__PURE__ */ p(Lt, { type: "bodyText3", sx: Be.titleText, children: n }), t[16] = n, t[17] = m) : m = t[17], l = ot, y = !0, w = Be.contentContainer, g = T ? /* @__PURE__ */ p(He, { variant: "rectangular", width: 100, height: 15 }) : A.map((H, $) => {
      const {
        markerOptions: q,
        text: Q,
        showMarker: S,
        showCopyIcon: Y,
        showWarning: nt,
        tooltipText: mt,
        extraContent: at
      } = H;
      return /* @__PURE__ */ O(ot, { container: !0, sx: Be.statusTextContainer, children: [
        S && /* @__PURE__ */ p(vi, { ...Z, ...q }),
        /* @__PURE__ */ p(si, { title: mt, placement: "top", slotProps: {
          popper: {
            modifiers: [{
              name: "offset",
              options: {
                offset: [0, -14]
              }
            }]
          }
        }, children: /* @__PURE__ */ O(ot, { container: !0, sx: Be.extraContent, children: [
          /* @__PURE__ */ p(Lt, { type: J, children: Q }),
          at && at.map((xt, Fe) => {
            const {
              showMarker: Pe,
              markerOptions: $e,
              text: B
            } = xt;
            return /* @__PURE__ */ O(ot, { container: !0, sx: Be.statusTextContainer, children: [
              Pe && /* @__PURE__ */ p(vi, { ...Z, ...$e }),
              /* @__PURE__ */ p(Lt, { type: J, children: B })
            ] }, `${n}-extra-content-${B}-${Fe}`);
          })
        ] }) }),
        Y && /* @__PURE__ */ p(Vo, { text: Q }),
        nt && /* @__PURE__ */ p(Qr, { sx: Be.warningIcon })
      ] }, `${n}-${Q}-${$}`);
    }), t[0] = i, t[1] = r, t[2] = o, t[3] = a, t[4] = s, t[5] = n, t[6] = l, t[7] = u, t[8] = f, t[9] = P, t[10] = _, t[11] = m, t[12] = y, t[13] = w, t[14] = g, t[15] = N;
  } else
    l = t[6], u = t[7], f = t[8], P = t[9], _ = t[10], m = t[11], y = t[12], w = t[13], g = t[14], N = t[15];
  let V;
  t[18] !== l || t[19] !== y || t[20] !== w || t[21] !== g ? (V = /* @__PURE__ */ p(l, { container: y, sx: w, children: g }), t[18] = l, t[19] = y, t[20] = w, t[21] = g, t[22] = V) : V = t[22];
  let L;
  return t[23] !== u || t[24] !== f || t[25] !== P || t[26] !== _ || t[27] !== m || t[28] !== V || t[29] !== N ? (L = /* @__PURE__ */ O(u, { container: N, sx: f, gap: P, width: _, children: [
    m,
    V
  ] }), t[23] = u, t[24] = f, t[25] = P, t[26] = _, t[27] = m, t[28] = V, t[29] = N, t[30] = L) : L = t[30], L;
}
const ea = [];
function na(e) {
  const {
    data: t,
    subtitle: n = "Current Count",
    title: i,
    value: r,
    color: o,
    timezone: a,
    loading: s = !1,
    titleIcon: l,
    hideYAxis: u,
    hideXAxisLabel: f,
    height: P,
    lineWidth: _,
    hideCrossHair: m,
    filledMarker: y,
    padding: w = 4,
    visibleDataPointIndexes: g = ea,
    tooltip: N,
    valueDescription: V
  } = e, L = me(() => ({
    time: {
      timezone: a,
      useUTC: !1
    },
    chart: {
      backgroundColor: "transparent",
      zooming: {
        type: "x"
      },
      height: P || "192px",
      type: "areaspline"
    },
    credits: {
      enabled: !1
    },
    title: {
      text: ""
    },
    accessibility: {
      enabled: !1
    },
    xAxis: {
      visible: !f,
      type: "datetime",
      ...!f && {
        tickLength: 0
      },
      labels: {
        enabled: !f,
        style: {
          color: "#747982"
        },
        formatter: function() {
          return ti(this.value).tz(a).format("MMM DD<br />h:mm a");
        }
      },
      crosshair: {
        width: 1,
        color: o,
        zIndex: 5,
        dashStyle: "LongDash",
        ...m && {
          width: 0
        }
      }
    },
    legend: {
      enabled: !1
    },
    exporting: {
      enabled: !1
    },
    tooltip: {
      useHTML: !0,
      style: {
        color: "#fff",
        fontSize: "12px"
      },
      backgroundColor: "#272B2F",
      formatter: function() {
        let A = N?.unit || "", T = 0;
        if (typeof this.y == "number")
          if (N?.unit?.includes("bytes")) {
            const {
              value: z,
              unit: J
            } = ko(this.y);
            T = z, A = J;
          } else
            T = Uo(this.y);
        return `<b>${this.series.name}</b><br/>${ti(this.x).tz(a).format("MMM DD, YYYY h:mm a z")}<br />${N?.text ? N?.text + ": " : ""}<b>${typeof this.y == "number" ? T : this.y}</b> ${A}<br/>`;
      }
    },
    yAxis: {
      ...t.length === 0 && {
        min: 0,
        max: 16
      },
      visible: !u,
      gridLineDashStyle: "LongDash",
      gridLineColor: t.length >= 1 ? o : "rgba(116,121,130, 0.3)",
      labels: {
        style: {
          color: "#747982"
        }
      },
      title: {
        text: ""
      }
    },
    plotOptions: {
      series: {
        connectEnds: !0,
        connectNulls: !0,
        lineWidth: _ || 2,
        color: o,
        // change Line color
        marker: {
          enabled: !1,
          fillColor: "#000",
          lineWidth: 2,
          ...y && {
            fillColor: o,
            lineWidth: 0.5
          }
        },
        states: {
          inactive: {
            opacity: 1
          }
        }
      }
    },
    series: [{
      name: i,
      type: "areaspline",
      // Highcharts writes back into series.options.data while diffing points on an
      // update (Point.update assigns seriesOptions.data[i]), so it must own the array.
      // Callers hand us immer-frozen Redux slices, and mutating one throws
      // "Cannot assign to read only property" on the first polled refresh.
      data: [...t],
      fillOpacity: 0.2
    }, {
      name: i,
      type: "scatter",
      lineWidth: 0,
      marker: {
        enabled: !0,
        symbol: "circle",
        fillColor: "#000"
      },
      data: t.filter((A, T) => g.includes(T))
    }]
  }), [o, t, i, a, f, u, P, _, m, y, g, N?.text, N?.unit]);
  return (
    // Replace the following static color once it is included in the color palette
    /* @__PURE__ */ p(ot, { container: !0, flexDirection: "column", flexWrap: "nowrap", padding: w, borderRadius: 1, bgcolor: "#fff", sx: {
      width: "100%",
      minWidth: 0
    }, children: s ? /* @__PURE__ */ O(an, { children: [
      /* @__PURE__ */ O(ot, { container: !0, justifyContent: "space-between", flexWrap: "nowrap", paddingBottom: 4, children: [
        /* @__PURE__ */ p(He, { width: 100, height: 20, variant: "rounded" }),
        /* @__PURE__ */ p(He, { width: 100, height: 20, variant: "rounded" })
      ] }),
      /* @__PURE__ */ p(He, { width: "100%", height: 192, variant: "rounded" })
    ] }) : /* @__PURE__ */ O(an, { children: [
      (i || n) && /* @__PURE__ */ O(ot, { container: !0, flexWrap: "nowrap", paddingBottom: 4, justifyContent: "space-between", children: [
        /* @__PURE__ */ O(ot, { container: !0, justifyContent: "center", alignItems: "center", flexWrap: "nowrap", gap: 1, width: "fit-content", children: [
          l,
          /* @__PURE__ */ p(Lt, { type: "bodyText2", sx: {
            textTransform: "capitalize",
            color: (A) => A.vars?.palette.grey[900] ?? A.palette.grey[900]
          }, children: i })
        ] }),
        /* @__PURE__ */ O(ot, { container: !0, justifyContent: "center", alignItems: "center", flexWrap: "nowrap", gap: 1, width: "fit-content", children: [
          /* @__PURE__ */ p(Lt, { type: "bodyText3", sx: {
            color: (A) => A.vars?.palette.grey[600] ?? A.palette.grey[600]
          }, children: n }),
          /* @__PURE__ */ p(Lt, { type: "bodyText1", sx: {
            color: (A) => A.vars?.palette.grey[900] ?? A.palette.grey[900]
          }, children: r }),
          V && /* @__PURE__ */ p(si, { title: V, placement: "bottom-end", children: /* @__PURE__ */ p(jr, { fontSize: "small", sx: {
            color: "#D7D7D7"
          } }) })
        ] })
      ] }),
      /* @__PURE__ */ p(ot, { sx: {
        position: "relative",
        width: "100%",
        minWidth: 0
      }, children: t.length !== 0 ? /* @__PURE__ */ p(yo, { highcharts: No, options: L }) : /* @__PURE__ */ p(ot, { display: "flex", justifyContent: "center", alignItems: "center", paddingY: 5, children: /* @__PURE__ */ p(Lt, { type: "heading1", children: "No data available" }) }) })
    ] }) })
  );
}
var ia = { value: () => {
} };
function Xi() {
  for (var e = 0, t = arguments.length, n = {}, i; e < t; ++e) {
    if (!(i = arguments[e] + "") || i in n || /[\s.]/.test(i)) throw new Error("illegal type: " + i);
    n[i] = [];
  }
  return new Dn(n);
}
function Dn(e) {
  this._ = e;
}
function ra(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var i = "", r = n.indexOf(".");
    if (r >= 0 && (i = n.slice(r + 1), n = n.slice(0, r)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: i };
  });
}
Dn.prototype = Xi.prototype = {
  constructor: Dn,
  on: function(e, t) {
    var n = this._, i = ra(e + "", n), r, o = -1, a = i.length;
    if (arguments.length < 2) {
      for (; ++o < a; ) if ((r = (e = i[o]).type) && (r = oa(n[r], e.name))) return r;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++o < a; )
      if (r = (e = i[o]).type) n[r] = Li(n[r], e.name, t);
      else if (t == null) for (r in n) n[r] = Li(n[r], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new Dn(e);
  },
  call: function(e, t) {
    if ((r = arguments.length - 2) > 0) for (var n = new Array(r), i = 0, r, o; i < r; ++i) n[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (o = this._[e], i = 0, r = o.length; i < r; ++i) o[i].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var i = this._[e], r = 0, o = i.length; r < o; ++r) i[r].value.apply(t, n);
  }
};
function oa(e, t) {
  for (var n = 0, i = e.length, r; n < i; ++n)
    if ((r = e[n]).name === t)
      return r.value;
}
function Li(e, t, n) {
  for (var i = 0, r = e.length; i < r; ++i)
    if (e[i].name === t) {
      e[i] = ia, e = e.slice(0, i).concat(e.slice(i + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var ei = "http://www.w3.org/1999/xhtml";
const Ii = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: ei,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Bn(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Ii.hasOwnProperty(t) ? { space: Ii[t], local: e } : e;
}
function aa(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === ei && t.documentElement.namespaceURI === ei ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function la(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Gi(e) {
  var t = Bn(e);
  return (t.local ? la : aa)(t);
}
function sa() {
}
function ci(e) {
  return e == null ? sa : function() {
    return this.querySelector(e);
  };
}
function ca(e) {
  typeof e != "function" && (e = ci(e));
  for (var t = this._groups, n = t.length, i = new Array(n), r = 0; r < n; ++r)
    for (var o = t[r], a = o.length, s = i[r] = new Array(a), l, u, f = 0; f < a; ++f)
      (l = o[f]) && (u = e.call(l, l.__data__, f, o)) && ("__data__" in l && (u.__data__ = l.__data__), s[f] = u);
  return new Ut(i, this._parents);
}
function ua(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function fa() {
  return [];
}
function qi(e) {
  return e == null ? fa : function() {
    return this.querySelectorAll(e);
  };
}
function pa(e) {
  return function() {
    return ua(e.apply(this, arguments));
  };
}
function da(e) {
  typeof e == "function" ? e = pa(e) : e = qi(e);
  for (var t = this._groups, n = t.length, i = [], r = [], o = 0; o < n; ++o)
    for (var a = t[o], s = a.length, l, u = 0; u < s; ++u)
      (l = a[u]) && (i.push(e.call(l, l.__data__, u, a)), r.push(l));
  return new Ut(i, r);
}
function Ki(e) {
  return function() {
    return this.matches(e);
  };
}
function Ji(e) {
  return function(t) {
    return t.matches(e);
  };
}
var ma = Array.prototype.find;
function ha(e) {
  return function() {
    return ma.call(this.children, e);
  };
}
function ga() {
  return this.firstElementChild;
}
function _a(e) {
  return this.select(e == null ? ga : ha(typeof e == "function" ? e : Ji(e)));
}
var Pa = Array.prototype.filter;
function xa() {
  return Array.from(this.children);
}
function wa(e) {
  return function() {
    return Pa.call(this.children, e);
  };
}
function ya(e) {
  return this.selectAll(e == null ? xa : wa(typeof e == "function" ? e : Ji(e)));
}
function Na(e) {
  typeof e != "function" && (e = Ki(e));
  for (var t = this._groups, n = t.length, i = new Array(n), r = 0; r < n; ++r)
    for (var o = t[r], a = o.length, s = i[r] = [], l, u = 0; u < a; ++u)
      (l = o[u]) && e.call(l, l.__data__, u, o) && s.push(l);
  return new Ut(i, this._parents);
}
function Zi(e) {
  return new Array(e.length);
}
function ba() {
  return new Ut(this._enter || this._groups.map(Zi), this._parents);
}
function Fn(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
Fn.prototype = {
  constructor: Fn,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function va(e) {
  return function() {
    return e;
  };
}
function Aa(e, t, n, i, r, o) {
  for (var a = 0, s, l = t.length, u = o.length; a < u; ++a)
    (s = t[a]) ? (s.__data__ = o[a], i[a] = s) : n[a] = new Fn(e, o[a]);
  for (; a < l; ++a)
    (s = t[a]) && (r[a] = s);
}
function Ca(e, t, n, i, r, o, a) {
  var s, l, u = /* @__PURE__ */ new Map(), f = t.length, P = o.length, _ = new Array(f), m;
  for (s = 0; s < f; ++s)
    (l = t[s]) && (_[s] = m = a.call(l, l.__data__, s, t) + "", u.has(m) ? r[s] = l : u.set(m, l));
  for (s = 0; s < P; ++s)
    m = a.call(e, o[s], s, o) + "", (l = u.get(m)) ? (i[s] = l, l.__data__ = o[s], u.delete(m)) : n[s] = new Fn(e, o[s]);
  for (s = 0; s < f; ++s)
    (l = t[s]) && u.get(_[s]) === l && (r[s] = l);
}
function La(e) {
  return e.__data__;
}
function Ia(e, t) {
  if (!arguments.length) return Array.from(this, La);
  var n = t ? Ca : Aa, i = this._parents, r = this._groups;
  typeof e != "function" && (e = va(e));
  for (var o = r.length, a = new Array(o), s = new Array(o), l = new Array(o), u = 0; u < o; ++u) {
    var f = i[u], P = r[u], _ = P.length, m = Oa(e.call(f, f && f.__data__, u, i)), y = m.length, w = s[u] = new Array(y), g = a[u] = new Array(y), N = l[u] = new Array(_);
    n(f, P, w, g, N, m, t);
    for (var V = 0, L = 0, A, T; V < y; ++V)
      if (A = w[V]) {
        for (V >= L && (L = V + 1); !(T = g[L]) && ++L < y; ) ;
        A._next = T || null;
      }
  }
  return a = new Ut(a, i), a._enter = s, a._exit = l, a;
}
function Oa(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Ma() {
  return new Ut(this._exit || this._groups.map(Zi), this._parents);
}
function Sa(e, t, n) {
  var i = this.enter(), r = this, o = this.exit();
  return typeof e == "function" ? (i = e(i), i && (i = i.selection())) : i = i.append(e + ""), t != null && (r = t(r), r && (r = r.selection())), n == null ? o.remove() : n(o), i && r ? i.merge(r).order() : r;
}
function Ta(e) {
  for (var t = e.selection ? e.selection() : e, n = this._groups, i = t._groups, r = n.length, o = i.length, a = Math.min(r, o), s = new Array(r), l = 0; l < a; ++l)
    for (var u = n[l], f = i[l], P = u.length, _ = s[l] = new Array(P), m, y = 0; y < P; ++y)
      (m = u[y] || f[y]) && (_[y] = m);
  for (; l < r; ++l)
    s[l] = n[l];
  return new Ut(s, this._parents);
}
function Da() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var i = e[t], r = i.length - 1, o = i[r], a; --r >= 0; )
      (a = i[r]) && (o && a.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(a, o), o = a);
  return this;
}
function Ra(e) {
  e || (e = Ea);
  function t(P, _) {
    return P && _ ? e(P.__data__, _.__data__) : !P - !_;
  }
  for (var n = this._groups, i = n.length, r = new Array(i), o = 0; o < i; ++o) {
    for (var a = n[o], s = a.length, l = r[o] = new Array(s), u, f = 0; f < s; ++f)
      (u = a[f]) && (l[f] = u);
    l.sort(t);
  }
  return new Ut(r, this._parents).order();
}
function Ea(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Fa() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function $a() {
  return Array.from(this);
}
function ka() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var i = e[t], r = 0, o = i.length; r < o; ++r) {
      var a = i[r];
      if (a) return a;
    }
  return null;
}
function Ua() {
  let e = 0;
  for (const t of this) ++e;
  return e;
}
function Va() {
  return !this.node();
}
function za(e) {
  for (var t = this._groups, n = 0, i = t.length; n < i; ++n)
    for (var r = t[n], o = 0, a = r.length, s; o < a; ++o)
      (s = r[o]) && e.call(s, s.__data__, o, r);
  return this;
}
function Ba(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function Wa(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function Ha(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function Ya(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function Xa(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function Ga(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function qa(e, t) {
  var n = Bn(e);
  if (arguments.length < 2) {
    var i = this.node();
    return n.local ? i.getAttributeNS(n.space, n.local) : i.getAttribute(n);
  }
  return this.each((t == null ? n.local ? Wa : Ba : typeof t == "function" ? n.local ? Ga : Xa : n.local ? Ya : Ha)(n, t));
}
function Qi(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function Ka(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Ja(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function Za(e, t, n) {
  return function() {
    var i = t.apply(this, arguments);
    i == null ? this.style.removeProperty(e) : this.style.setProperty(e, i, n);
  };
}
function Qa(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? Ka : typeof t == "function" ? Za : Ja)(e, t, n ?? "")) : ln(this.node(), e);
}
function ln(e, t) {
  return e.style.getPropertyValue(t) || Qi(e).getComputedStyle(e, null).getPropertyValue(t);
}
function ja(e) {
  return function() {
    delete this[e];
  };
}
function tl(e, t) {
  return function() {
    this[e] = t;
  };
}
function el(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function nl(e, t) {
  return arguments.length > 1 ? this.each((t == null ? ja : typeof t == "function" ? el : tl)(e, t)) : this.node()[e];
}
function ji(e) {
  return e.trim().split(/^|\s+/);
}
function ui(e) {
  return e.classList || new tr(e);
}
function tr(e) {
  this._node = e, this._names = ji(e.getAttribute("class") || "");
}
tr.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function er(e, t) {
  for (var n = ui(e), i = -1, r = t.length; ++i < r; ) n.add(t[i]);
}
function nr(e, t) {
  for (var n = ui(e), i = -1, r = t.length; ++i < r; ) n.remove(t[i]);
}
function il(e) {
  return function() {
    er(this, e);
  };
}
function rl(e) {
  return function() {
    nr(this, e);
  };
}
function ol(e, t) {
  return function() {
    (t.apply(this, arguments) ? er : nr)(this, e);
  };
}
function al(e, t) {
  var n = ji(e + "");
  if (arguments.length < 2) {
    for (var i = ui(this.node()), r = -1, o = n.length; ++r < o; ) if (!i.contains(n[r])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? ol : t ? il : rl)(n, t));
}
function ll() {
  this.textContent = "";
}
function sl(e) {
  return function() {
    this.textContent = e;
  };
}
function cl(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function ul(e) {
  return arguments.length ? this.each(e == null ? ll : (typeof e == "function" ? cl : sl)(e)) : this.node().textContent;
}
function fl() {
  this.innerHTML = "";
}
function pl(e) {
  return function() {
    this.innerHTML = e;
  };
}
function dl(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function ml(e) {
  return arguments.length ? this.each(e == null ? fl : (typeof e == "function" ? dl : pl)(e)) : this.node().innerHTML;
}
function hl() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function gl() {
  return this.each(hl);
}
function _l() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Pl() {
  return this.each(_l);
}
function xl(e) {
  var t = typeof e == "function" ? e : Gi(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function wl() {
  return null;
}
function yl(e, t) {
  var n = typeof e == "function" ? e : Gi(e), i = t == null ? wl : typeof t == "function" ? t : ci(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), i.apply(this, arguments) || null);
  });
}
function Nl() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function bl() {
  return this.each(Nl);
}
function vl() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Al() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Cl(e) {
  return this.select(e ? Al : vl);
}
function Ll(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function Il(e) {
  return function(t) {
    e.call(this, t, this.__data__);
  };
}
function Ol(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", i = t.indexOf(".");
    return i >= 0 && (n = t.slice(i + 1), t = t.slice(0, i)), { type: t, name: n };
  });
}
function Ml(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, i = -1, r = t.length, o; n < r; ++n)
        o = t[n], (!e.type || o.type === e.type) && o.name === e.name ? this.removeEventListener(o.type, o.listener, o.options) : t[++i] = o;
      ++i ? t.length = i : delete this.__on;
    }
  };
}
function Sl(e, t, n) {
  return function() {
    var i = this.__on, r, o = Il(t);
    if (i) {
      for (var a = 0, s = i.length; a < s; ++a)
        if ((r = i[a]).type === e.type && r.name === e.name) {
          this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = o, r.options = n), r.value = t;
          return;
        }
    }
    this.addEventListener(e.type, o, n), r = { type: e.type, name: e.name, value: t, listener: o, options: n }, i ? i.push(r) : this.__on = [r];
  };
}
function Tl(e, t, n) {
  var i = Ol(e + ""), r, o = i.length, a;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, u = s.length, f; l < u; ++l)
        for (r = 0, f = s[l]; r < o; ++r)
          if ((a = i[r]).type === f.type && a.name === f.name)
            return f.value;
    }
    return;
  }
  for (s = t ? Sl : Ml, r = 0; r < o; ++r) this.each(s(i[r], t, n));
  return this;
}
function ir(e, t, n) {
  var i = Qi(e), r = i.CustomEvent;
  typeof r == "function" ? r = new r(t, n) : (r = i.document.createEvent("Event"), n ? (r.initEvent(t, n.bubbles, n.cancelable), r.detail = n.detail) : r.initEvent(t, !1, !1)), e.dispatchEvent(r);
}
function Dl(e, t) {
  return function() {
    return ir(this, e, t);
  };
}
function Rl(e, t) {
  return function() {
    return ir(this, e, t.apply(this, arguments));
  };
}
function El(e, t) {
  return this.each((typeof t == "function" ? Rl : Dl)(e, t));
}
function* Fl() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var i = e[t], r = 0, o = i.length, a; r < o; ++r)
      (a = i[r]) && (yield a);
}
var $l = [null];
function Ut(e, t) {
  this._groups = e, this._parents = t;
}
function bn() {
  return new Ut([[document.documentElement]], $l);
}
function kl() {
  return this;
}
Ut.prototype = bn.prototype = {
  constructor: Ut,
  select: ca,
  selectAll: da,
  selectChild: _a,
  selectChildren: ya,
  filter: Na,
  data: Ia,
  enter: ba,
  exit: Ma,
  join: Sa,
  merge: Ta,
  selection: kl,
  order: Da,
  sort: Ra,
  call: Fa,
  nodes: $a,
  node: ka,
  size: Ua,
  empty: Va,
  each: za,
  attr: qa,
  style: Qa,
  property: nl,
  classed: al,
  text: ul,
  html: ml,
  raise: gl,
  lower: Pl,
  append: xl,
  insert: yl,
  remove: bl,
  clone: Cl,
  datum: Ll,
  on: Tl,
  dispatch: El,
  [Symbol.iterator]: Fl
};
function fi(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function rr(e, t) {
  var n = Object.create(e.prototype);
  for (var i in t) n[i] = t[i];
  return n;
}
function vn() {
}
var xn = 0.7, $n = 1 / xn, on = "\\s*([+-]?\\d+)\\s*", wn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Zt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Ul = /^#([0-9a-f]{3,8})$/, Vl = new RegExp(`^rgb\\(${on},${on},${on}\\)$`), zl = new RegExp(`^rgb\\(${Zt},${Zt},${Zt}\\)$`), Bl = new RegExp(`^rgba\\(${on},${on},${on},${wn}\\)$`), Wl = new RegExp(`^rgba\\(${Zt},${Zt},${Zt},${wn}\\)$`), Hl = new RegExp(`^hsl\\(${wn},${Zt},${Zt}\\)$`), Yl = new RegExp(`^hsla\\(${wn},${Zt},${Zt},${wn}\\)$`), Oi = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
fi(vn, yn, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Mi,
  // Deprecated! Use color.formatHex.
  formatHex: Mi,
  formatHex8: Xl,
  formatHsl: Gl,
  formatRgb: Si,
  toString: Si
});
function Mi() {
  return this.rgb().formatHex();
}
function Xl() {
  return this.rgb().formatHex8();
}
function Gl() {
  return or(this).formatHsl();
}
function Si() {
  return this.rgb().formatRgb();
}
function yn(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Ul.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Ti(t) : n === 3 ? new vt(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? In(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? In(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Vl.exec(e)) ? new vt(t[1], t[2], t[3], 1) : (t = zl.exec(e)) ? new vt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Bl.exec(e)) ? In(t[1], t[2], t[3], t[4]) : (t = Wl.exec(e)) ? In(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Hl.exec(e)) ? Ei(t[1], t[2] / 100, t[3] / 100, 1) : (t = Yl.exec(e)) ? Ei(t[1], t[2] / 100, t[3] / 100, t[4]) : Oi.hasOwnProperty(e) ? Ti(Oi[e]) : e === "transparent" ? new vt(NaN, NaN, NaN, 0) : null;
}
function Ti(e) {
  return new vt(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function In(e, t, n, i) {
  return i <= 0 && (e = t = n = NaN), new vt(e, t, n, i);
}
function ql(e) {
  return e instanceof vn || (e = yn(e)), e ? (e = e.rgb(), new vt(e.r, e.g, e.b, e.opacity)) : new vt();
}
function ni(e, t, n, i) {
  return arguments.length === 1 ? ql(e) : new vt(e, t, n, i ?? 1);
}
function vt(e, t, n, i) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +i;
}
fi(vt, ni, rr(vn, {
  brighter(e) {
    return e = e == null ? $n : Math.pow($n, e), new vt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? xn : Math.pow(xn, e), new vt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new vt(Ye(this.r), Ye(this.g), Ye(this.b), kn(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Di,
  // Deprecated! Use color.formatHex.
  formatHex: Di,
  formatHex8: Kl,
  formatRgb: Ri,
  toString: Ri
}));
function Di() {
  return `#${We(this.r)}${We(this.g)}${We(this.b)}`;
}
function Kl() {
  return `#${We(this.r)}${We(this.g)}${We(this.b)}${We((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Ri() {
  const e = kn(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Ye(this.r)}, ${Ye(this.g)}, ${Ye(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function kn(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Ye(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function We(e) {
  return e = Ye(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Ei(e, t, n, i) {
  return i <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new kt(e, t, n, i);
}
function or(e) {
  if (e instanceof kt) return new kt(e.h, e.s, e.l, e.opacity);
  if (e instanceof vn || (e = yn(e)), !e) return new kt();
  if (e instanceof kt) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, i = e.b / 255, r = Math.min(t, n, i), o = Math.max(t, n, i), a = NaN, s = o - r, l = (o + r) / 2;
  return s ? (t === o ? a = (n - i) / s + (n < i) * 6 : n === o ? a = (i - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? o + r : 2 - o - r, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new kt(a, s, l, e.opacity);
}
function Jl(e, t, n, i) {
  return arguments.length === 1 ? or(e) : new kt(e, t, n, i ?? 1);
}
function kt(e, t, n, i) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +i;
}
fi(kt, Jl, rr(vn, {
  brighter(e) {
    return e = e == null ? $n : Math.pow($n, e), new kt(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? xn : Math.pow(xn, e), new kt(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, i = n + (n < 0.5 ? n : 1 - n) * t, r = 2 * n - i;
    return new vt(
      Zn(e >= 240 ? e - 240 : e + 120, r, i),
      Zn(e, r, i),
      Zn(e < 120 ? e + 240 : e - 120, r, i),
      this.opacity
    );
  },
  clamp() {
    return new kt(Fi(this.h), On(this.s), On(this.l), kn(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = kn(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Fi(this.h)}, ${On(this.s) * 100}%, ${On(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Fi(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function On(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Zn(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const ar = (e) => () => e;
function Zl(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Ql(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(i) {
    return Math.pow(e + i * t, n);
  };
}
function jl(e) {
  return (e = +e) == 1 ? lr : function(t, n) {
    return n - t ? Ql(t, n, e) : ar(isNaN(t) ? n : t);
  };
}
function lr(e, t) {
  var n = t - e;
  return n ? Zl(e, n) : ar(isNaN(e) ? t : e);
}
const $i = (function e(t) {
  var n = jl(t);
  function i(r, o) {
    var a = n((r = ni(r)).r, (o = ni(o)).r), s = n(r.g, o.g), l = n(r.b, o.b), u = lr(r.opacity, o.opacity);
    return function(f) {
      return r.r = a(f), r.g = s(f), r.b = l(f), r.opacity = u(f), r + "";
    };
  }
  return i.gamma = e, i;
})(1);
function Ee(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
var ii = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Qn = new RegExp(ii.source, "g");
function ts(e) {
  return function() {
    return e;
  };
}
function es(e) {
  return function(t) {
    return e(t) + "";
  };
}
function ns(e, t) {
  var n = ii.lastIndex = Qn.lastIndex = 0, i, r, o, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (i = ii.exec(e)) && (r = Qn.exec(t)); )
    (o = r.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (i = i[0]) === (r = r[0]) ? s[a] ? s[a] += r : s[++a] = r : (s[++a] = null, l.push({ i: a, x: Ee(i, r) })), n = Qn.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? l[0] ? es(l[0].x) : ts(t) : (t = l.length, function(u) {
    for (var f = 0, P; f < t; ++f) s[(P = l[f]).i] = P.x(u);
    return s.join("");
  });
}
var ki = 180 / Math.PI, ri = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function sr(e, t, n, i, r, o) {
  var a, s, l;
  return (a = Math.sqrt(e * e + t * t)) && (e /= a, t /= a), (l = e * n + t * i) && (n -= e * l, i -= t * l), (s = Math.sqrt(n * n + i * i)) && (n /= s, i /= s, l /= s), e * i < t * n && (e = -e, t = -t, l = -l, a = -a), {
    translateX: r,
    translateY: o,
    rotate: Math.atan2(t, e) * ki,
    skewX: Math.atan(l) * ki,
    scaleX: a,
    scaleY: s
  };
}
var Mn;
function is(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? ri : sr(t.a, t.b, t.c, t.d, t.e, t.f);
}
function rs(e) {
  return e == null || (Mn || (Mn = document.createElementNS("http://www.w3.org/2000/svg", "g")), Mn.setAttribute("transform", e), !(e = Mn.transform.baseVal.consolidate())) ? ri : (e = e.matrix, sr(e.a, e.b, e.c, e.d, e.e, e.f));
}
function cr(e, t, n, i) {
  function r(u) {
    return u.length ? u.pop() + " " : "";
  }
  function o(u, f, P, _, m, y) {
    if (u !== P || f !== _) {
      var w = m.push("translate(", null, t, null, n);
      y.push({ i: w - 4, x: Ee(u, P) }, { i: w - 2, x: Ee(f, _) });
    } else (P || _) && m.push("translate(" + P + t + _ + n);
  }
  function a(u, f, P, _) {
    u !== f ? (u - f > 180 ? f += 360 : f - u > 180 && (u += 360), _.push({ i: P.push(r(P) + "rotate(", null, i) - 2, x: Ee(u, f) })) : f && P.push(r(P) + "rotate(" + f + i);
  }
  function s(u, f, P, _) {
    u !== f ? _.push({ i: P.push(r(P) + "skewX(", null, i) - 2, x: Ee(u, f) }) : f && P.push(r(P) + "skewX(" + f + i);
  }
  function l(u, f, P, _, m, y) {
    if (u !== P || f !== _) {
      var w = m.push(r(m) + "scale(", null, ",", null, ")");
      y.push({ i: w - 4, x: Ee(u, P) }, { i: w - 2, x: Ee(f, _) });
    } else (P !== 1 || _ !== 1) && m.push(r(m) + "scale(" + P + "," + _ + ")");
  }
  return function(u, f) {
    var P = [], _ = [];
    return u = e(u), f = e(f), o(u.translateX, u.translateY, f.translateX, f.translateY, P, _), a(u.rotate, f.rotate, P, _), s(u.skewX, f.skewX, P, _), l(u.scaleX, u.scaleY, f.scaleX, f.scaleY, P, _), u = f = null, function(m) {
      for (var y = -1, w = _.length, g; ++y < w; ) P[(g = _[y]).i] = g.x(m);
      return P.join("");
    };
  };
}
var os = cr(is, "px, ", "px)", "deg)"), as = cr(rs, ", ", ")", ")"), sn = 0, gn = 0, hn = 0, ur = 1e3, Un, _n, Vn = 0, Xe = 0, Wn = 0, Nn = typeof performance == "object" && performance.now ? performance : Date, fr = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function pi() {
  return Xe || (fr(ls), Xe = Nn.now() + Wn);
}
function ls() {
  Xe = 0;
}
function zn() {
  this._call = this._time = this._next = null;
}
zn.prototype = pr.prototype = {
  constructor: zn,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? pi() : +n) + (t == null ? 0 : +t), !this._next && _n !== this && (_n ? _n._next = this : Un = this, _n = this), this._call = e, this._time = n, oi();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, oi());
  }
};
function pr(e, t, n) {
  var i = new zn();
  return i.restart(e, t, n), i;
}
function ss() {
  pi(), ++sn;
  for (var e = Un, t; e; )
    (t = Xe - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --sn;
}
function Ui() {
  Xe = (Vn = Nn.now()) + Wn, sn = gn = 0;
  try {
    ss();
  } finally {
    sn = 0, us(), Xe = 0;
  }
}
function cs() {
  var e = Nn.now(), t = e - Vn;
  t > ur && (Wn -= t, Vn = e);
}
function us() {
  for (var e, t = Un, n, i = 1 / 0; t; )
    t._call ? (i > t._time && (i = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : Un = n);
  _n = e, oi(i);
}
function oi(e) {
  if (!sn) {
    gn && (gn = clearTimeout(gn));
    var t = e - Xe;
    t > 24 ? (e < 1 / 0 && (gn = setTimeout(Ui, e - Nn.now() - Wn)), hn && (hn = clearInterval(hn))) : (hn || (Vn = Nn.now(), hn = setInterval(cs, ur)), sn = 1, fr(Ui));
  }
}
function Vi(e, t, n) {
  var i = new zn();
  return t = t == null ? 0 : +t, i.restart((r) => {
    i.stop(), e(r + t);
  }, t, n), i;
}
var fs = Xi("start", "end", "cancel", "interrupt"), ps = [], dr = 0, zi = 1, ai = 2, Rn = 3, Bi = 4, li = 5, En = 6;
function Hn(e, t, n, i, r, o) {
  var a = e.__transition;
  if (!a) e.__transition = {};
  else if (n in a) return;
  ds(e, n, {
    name: t,
    index: i,
    // For context during callback.
    group: r,
    // For context during callback.
    on: fs,
    tween: ps,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: dr
  });
}
function di(e, t) {
  var n = Vt(e, t);
  if (n.state > dr) throw new Error("too late; already scheduled");
  return n;
}
function Qt(e, t) {
  var n = Vt(e, t);
  if (n.state > Rn) throw new Error("too late; already running");
  return n;
}
function Vt(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function ds(e, t, n) {
  var i = e.__transition, r;
  i[t] = n, n.timer = pr(o, 0, n.time);
  function o(u) {
    n.state = zi, n.timer.restart(a, n.delay, n.time), n.delay <= u && a(u - n.delay);
  }
  function a(u) {
    var f, P, _, m;
    if (n.state !== zi) return l();
    for (f in i)
      if (m = i[f], m.name === n.name) {
        if (m.state === Rn) return Vi(a);
        m.state === Bi ? (m.state = En, m.timer.stop(), m.on.call("interrupt", e, e.__data__, m.index, m.group), delete i[f]) : +f < t && (m.state = En, m.timer.stop(), m.on.call("cancel", e, e.__data__, m.index, m.group), delete i[f]);
      }
    if (Vi(function() {
      n.state === Rn && (n.state = Bi, n.timer.restart(s, n.delay, n.time), s(u));
    }), n.state = ai, n.on.call("start", e, e.__data__, n.index, n.group), n.state === ai) {
      for (n.state = Rn, r = new Array(_ = n.tween.length), f = 0, P = -1; f < _; ++f)
        (m = n.tween[f].value.call(e, e.__data__, n.index, n.group)) && (r[++P] = m);
      r.length = P + 1;
    }
  }
  function s(u) {
    for (var f = u < n.duration ? n.ease.call(null, u / n.duration) : (n.timer.restart(l), n.state = li, 1), P = -1, _ = r.length; ++P < _; )
      r[P].call(e, f);
    n.state === li && (n.on.call("end", e, e.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = En, n.timer.stop(), delete i[t];
    for (var u in i) return;
    delete e.__transition;
  }
}
function ms(e, t) {
  var n = e.__transition, i, r, o = !0, a;
  if (n) {
    t = t == null ? null : t + "";
    for (a in n) {
      if ((i = n[a]).name !== t) {
        o = !1;
        continue;
      }
      r = i.state > ai && i.state < li, i.state = En, i.timer.stop(), i.on.call(r ? "interrupt" : "cancel", e, e.__data__, i.index, i.group), delete n[a];
    }
    o && delete e.__transition;
  }
}
function hs(e) {
  return this.each(function() {
    ms(this, e);
  });
}
function gs(e, t) {
  var n, i;
  return function() {
    var r = Qt(this, e), o = r.tween;
    if (o !== n) {
      i = n = o;
      for (var a = 0, s = i.length; a < s; ++a)
        if (i[a].name === t) {
          i = i.slice(), i.splice(a, 1);
          break;
        }
    }
    r.tween = i;
  };
}
function _s(e, t, n) {
  var i, r;
  if (typeof n != "function") throw new Error();
  return function() {
    var o = Qt(this, e), a = o.tween;
    if (a !== i) {
      r = (i = a).slice();
      for (var s = { name: t, value: n }, l = 0, u = r.length; l < u; ++l)
        if (r[l].name === t) {
          r[l] = s;
          break;
        }
      l === u && r.push(s);
    }
    o.tween = r;
  };
}
function Ps(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var i = Vt(this.node(), n).tween, r = 0, o = i.length, a; r < o; ++r)
      if ((a = i[r]).name === e)
        return a.value;
    return null;
  }
  return this.each((t == null ? gs : _s)(n, e, t));
}
function mi(e, t, n) {
  var i = e._id;
  return e.each(function() {
    var r = Qt(this, i);
    (r.value || (r.value = {}))[t] = n.apply(this, arguments);
  }), function(r) {
    return Vt(r, i).value[t];
  };
}
function mr(e, t) {
  var n;
  return (typeof t == "number" ? Ee : t instanceof yn ? $i : (n = yn(t)) ? (t = n, $i) : ns)(e, t);
}
function xs(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function ws(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function ys(e, t, n) {
  var i, r = n + "", o;
  return function() {
    var a = this.getAttribute(e);
    return a === r ? null : a === i ? o : o = t(i = a, n);
  };
}
function Ns(e, t, n) {
  var i, r = n + "", o;
  return function() {
    var a = this.getAttributeNS(e.space, e.local);
    return a === r ? null : a === i ? o : o = t(i = a, n);
  };
}
function bs(e, t, n) {
  var i, r, o;
  return function() {
    var a, s = n(this), l;
    return s == null ? void this.removeAttribute(e) : (a = this.getAttribute(e), l = s + "", a === l ? null : a === i && l === r ? o : (r = l, o = t(i = a, s)));
  };
}
function vs(e, t, n) {
  var i, r, o;
  return function() {
    var a, s = n(this), l;
    return s == null ? void this.removeAttributeNS(e.space, e.local) : (a = this.getAttributeNS(e.space, e.local), l = s + "", a === l ? null : a === i && l === r ? o : (r = l, o = t(i = a, s)));
  };
}
function As(e, t) {
  var n = Bn(e), i = n === "transform" ? as : mr;
  return this.attrTween(e, typeof t == "function" ? (n.local ? vs : bs)(n, i, mi(this, "attr." + e, t)) : t == null ? (n.local ? ws : xs)(n) : (n.local ? Ns : ys)(n, i, t));
}
function Cs(e, t) {
  return function(n) {
    this.setAttribute(e, t.call(this, n));
  };
}
function Ls(e, t) {
  return function(n) {
    this.setAttributeNS(e.space, e.local, t.call(this, n));
  };
}
function Is(e, t) {
  var n, i;
  function r() {
    var o = t.apply(this, arguments);
    return o !== i && (n = (i = o) && Ls(e, o)), n;
  }
  return r._value = t, r;
}
function Os(e, t) {
  var n, i;
  function r() {
    var o = t.apply(this, arguments);
    return o !== i && (n = (i = o) && Cs(e, o)), n;
  }
  return r._value = t, r;
}
function Ms(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var i = Bn(e);
  return this.tween(n, (i.local ? Is : Os)(i, t));
}
function Ss(e, t) {
  return function() {
    di(this, e).delay = +t.apply(this, arguments);
  };
}
function Ts(e, t) {
  return t = +t, function() {
    di(this, e).delay = t;
  };
}
function Ds(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Ss : Ts)(t, e)) : Vt(this.node(), t).delay;
}
function Rs(e, t) {
  return function() {
    Qt(this, e).duration = +t.apply(this, arguments);
  };
}
function Es(e, t) {
  return t = +t, function() {
    Qt(this, e).duration = t;
  };
}
function Fs(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Rs : Es)(t, e)) : Vt(this.node(), t).duration;
}
function $s(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Qt(this, e).ease = t;
  };
}
function ks(e) {
  var t = this._id;
  return arguments.length ? this.each($s(t, e)) : Vt(this.node(), t).ease;
}
function Us(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Qt(this, e).ease = n;
  };
}
function Vs(e) {
  if (typeof e != "function") throw new Error();
  return this.each(Us(this._id, e));
}
function zs(e) {
  typeof e != "function" && (e = Ki(e));
  for (var t = this._groups, n = t.length, i = new Array(n), r = 0; r < n; ++r)
    for (var o = t[r], a = o.length, s = i[r] = [], l, u = 0; u < a; ++u)
      (l = o[u]) && e.call(l, l.__data__, u, o) && s.push(l);
  return new ge(i, this._parents, this._name, this._id);
}
function Bs(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, i = t.length, r = n.length, o = Math.min(i, r), a = new Array(i), s = 0; s < o; ++s)
    for (var l = t[s], u = n[s], f = l.length, P = a[s] = new Array(f), _, m = 0; m < f; ++m)
      (_ = l[m] || u[m]) && (P[m] = _);
  for (; s < i; ++s)
    a[s] = t[s];
  return new ge(a, this._parents, this._name, this._id);
}
function Ws(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function Hs(e, t, n) {
  var i, r, o = Ws(t) ? di : Qt;
  return function() {
    var a = o(this, e), s = a.on;
    s !== i && (r = (i = s).copy()).on(t, n), a.on = r;
  };
}
function Ys(e, t) {
  var n = this._id;
  return arguments.length < 2 ? Vt(this.node(), n).on.on(e) : this.each(Hs(n, e, t));
}
function Xs(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function Gs() {
  return this.on("end.remove", Xs(this._id));
}
function qs(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = ci(e));
  for (var i = this._groups, r = i.length, o = new Array(r), a = 0; a < r; ++a)
    for (var s = i[a], l = s.length, u = o[a] = new Array(l), f, P, _ = 0; _ < l; ++_)
      (f = s[_]) && (P = e.call(f, f.__data__, _, s)) && ("__data__" in f && (P.__data__ = f.__data__), u[_] = P, Hn(u[_], t, n, _, u, Vt(f, n)));
  return new ge(o, this._parents, t, n);
}
function Ks(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = qi(e));
  for (var i = this._groups, r = i.length, o = [], a = [], s = 0; s < r; ++s)
    for (var l = i[s], u = l.length, f, P = 0; P < u; ++P)
      if (f = l[P]) {
        for (var _ = e.call(f, f.__data__, P, l), m, y = Vt(f, n), w = 0, g = _.length; w < g; ++w)
          (m = _[w]) && Hn(m, t, n, w, _, y);
        o.push(_), a.push(f);
      }
  return new ge(o, a, t, n);
}
var Js = bn.prototype.constructor;
function Zs() {
  return new Js(this._groups, this._parents);
}
function Qs(e, t) {
  var n, i, r;
  return function() {
    var o = ln(this, e), a = (this.style.removeProperty(e), ln(this, e));
    return o === a ? null : o === n && a === i ? r : r = t(n = o, i = a);
  };
}
function hr(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function js(e, t, n) {
  var i, r = n + "", o;
  return function() {
    var a = ln(this, e);
    return a === r ? null : a === i ? o : o = t(i = a, n);
  };
}
function tc(e, t, n) {
  var i, r, o;
  return function() {
    var a = ln(this, e), s = n(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(e), ln(this, e))), a === l ? null : a === i && l === r ? o : (r = l, o = t(i = a, s));
  };
}
function ec(e, t) {
  var n, i, r, o = "style." + t, a = "end." + o, s;
  return function() {
    var l = Qt(this, e), u = l.on, f = l.value[o] == null ? s || (s = hr(t)) : void 0;
    (u !== n || r !== f) && (i = (n = u).copy()).on(a, r = f), l.on = i;
  };
}
function nc(e, t, n) {
  var i = (e += "") == "transform" ? os : mr;
  return t == null ? this.styleTween(e, Qs(e, i)).on("end.style." + e, hr(e)) : typeof t == "function" ? this.styleTween(e, tc(e, i, mi(this, "style." + e, t))).each(ec(this._id, e)) : this.styleTween(e, js(e, i, t), n).on("end.style." + e, null);
}
function ic(e, t, n) {
  return function(i) {
    this.style.setProperty(e, t.call(this, i), n);
  };
}
function rc(e, t, n) {
  var i, r;
  function o() {
    var a = t.apply(this, arguments);
    return a !== r && (i = (r = a) && ic(e, a, n)), i;
  }
  return o._value = t, o;
}
function oc(e, t, n) {
  var i = "style." + (e += "");
  if (arguments.length < 2) return (i = this.tween(i)) && i._value;
  if (t == null) return this.tween(i, null);
  if (typeof t != "function") throw new Error();
  return this.tween(i, rc(e, t, n ?? ""));
}
function ac(e) {
  return function() {
    this.textContent = e;
  };
}
function lc(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function sc(e) {
  return this.tween("text", typeof e == "function" ? lc(mi(this, "text", e)) : ac(e == null ? "" : e + ""));
}
function cc(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function uc(e) {
  var t, n;
  function i() {
    var r = e.apply(this, arguments);
    return r !== n && (t = (n = r) && cc(r)), t;
  }
  return i._value = e, i;
}
function fc(e) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (e == null) return this.tween(t, null);
  if (typeof e != "function") throw new Error();
  return this.tween(t, uc(e));
}
function pc() {
  for (var e = this._name, t = this._id, n = gr(), i = this._groups, r = i.length, o = 0; o < r; ++o)
    for (var a = i[o], s = a.length, l, u = 0; u < s; ++u)
      if (l = a[u]) {
        var f = Vt(l, t);
        Hn(l, e, n, u, a, {
          time: f.time + f.delay + f.duration,
          delay: 0,
          duration: f.duration,
          ease: f.ease
        });
      }
  return new ge(i, this._parents, e, n);
}
function dc() {
  var e, t, n = this, i = n._id, r = n.size();
  return new Promise(function(o, a) {
    var s = { value: a }, l = { value: function() {
      --r === 0 && o();
    } };
    n.each(function() {
      var u = Qt(this, i), f = u.on;
      f !== e && (t = (e = f).copy(), t._.cancel.push(s), t._.interrupt.push(s), t._.end.push(l)), u.on = t;
    }), r === 0 && o();
  });
}
var mc = 0;
function ge(e, t, n, i) {
  this._groups = e, this._parents = t, this._name = n, this._id = i;
}
function gr() {
  return ++mc;
}
var pe = bn.prototype;
ge.prototype = {
  constructor: ge,
  select: qs,
  selectAll: Ks,
  selectChild: pe.selectChild,
  selectChildren: pe.selectChildren,
  filter: zs,
  merge: Bs,
  selection: Zs,
  transition: pc,
  call: pe.call,
  nodes: pe.nodes,
  node: pe.node,
  size: pe.size,
  empty: pe.empty,
  each: pe.each,
  on: Ys,
  attr: As,
  attrTween: Ms,
  style: nc,
  styleTween: oc,
  text: sc,
  textTween: fc,
  remove: Gs,
  tween: Ps,
  delay: Ds,
  duration: Fs,
  ease: ks,
  easeVarying: Vs,
  end: dc,
  [Symbol.iterator]: pe[Symbol.iterator]
};
function hc(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var gc = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: hc
};
function _c(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${t} not found`);
  return n;
}
function Pc(e) {
  var t, n;
  e instanceof ge ? (t = e._id, e = e._name) : (t = gr(), (n = gc).time = pi(), e = e == null ? null : e + "");
  for (var i = this._groups, r = i.length, o = 0; o < r; ++o)
    for (var a = i[o], s = a.length, l, u = 0; u < s; ++u)
      (l = a[u]) && Hn(l, e, t, u, a, n || _c(l, t));
  return new ge(i, this._parents, e, t);
}
bn.prototype.interrupt = hs;
bn.prototype.transition = Pc;
function rn(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
rn.prototype = {
  constructor: rn,
  scale: function(e) {
    return e === 1 ? this : new rn(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new rn(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var ad = new rn(1, 0, 0);
rn.prototype;
const xc = {
  color: "#7579F5",
  data: [],
  title: "",
  subtitle: "",
  value: 0,
  timezone: ti.tz.guess(),
  hideYAxis: !0,
  hideXAxisLabel: !0,
  height: "57px",
  lineWidth: 1.75,
  hideCrossHair: !0,
  filledMarker: !0,
  padding: 0
};
function ld(e) {
  const t = _e(8), {
    textWidgetProps: n,
    statusTextWidgetProps: i,
    splineGraphProps: r,
    chipText: o,
    variant: a,
    outlined: s,
    loading: l
  } = e, u = a === void 0 ? "status" : a, f = s === void 0 ? !1 : s, P = l === void 0 ? !1 : l;
  let _;
  return t[0] !== o || t[1] !== P || t[2] !== f || t[3] !== r || t[4] !== i || t[5] !== n || t[6] !== u ? (_ = P ? /* @__PURE__ */ p(He, { variant: "rectangular", width: "100%", height: 100 }) : /* @__PURE__ */ O(ot, { container: !0, sx: [Ln.container, f && Ln.outlined], children: [
    /* @__PURE__ */ O(ot, { container: !0, sx: Ln.contentContainer, children: [
      u === "status" && /* @__PURE__ */ p(ta, { ...i }),
      u === "percentage" && /* @__PURE__ */ p(Jo, { ...n }),
      o && /* @__PURE__ */ p(bo, { label: o, sx: Ln.chip })
    ] }),
    /* @__PURE__ */ p(na, { ...xc, ...r })
  ] }), t[0] = o, t[1] = P, t[2] = f, t[3] = r, t[4] = i, t[5] = n, t[6] = u, t[7] = _) : _ = t[7], _;
}
const _r = (e) => {
  const t = _e(36), {
    children: n,
    style: i,
    sx: r,
    toolbar: o,
    onNodeSelect: a,
    onExpandedItemsChange: s,
    expandedItems: l,
    defaultExpandedItems: u,
    collapseIcon: f,
    expandIcon: P,
    data: _,
    renderItem: m,
    selected: y,
    itemChildrenIndentation: w,
    urlParamKey: g
  } = e, N = f === void 0 ? ho : f, V = P === void 0 ? Ro : P, L = w === void 0 ? 20 : w, A = g === void 0 ? "menuID" : g;
  let T;
  t[0] !== A ? (T = new URLSearchParams(window.location.search).get(A), t[0] = A, t[1] = T) : T = t[1];
  const z = T;
  let J;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (J = {
    xs: 12
  }, t[2] = J) : J = t[2];
  let F;
  t[3] !== i || t[4] !== r ? (F = {
    marginTop: "0.2rem",
    padding: ".5rem",
    borderRadius: "4px",
    overflow: "auto",
    ...i,
    ...r
  }, t[3] = i, t[4] = r, t[5] = F) : F = t[5];
  let Z;
  t[6] !== n || t[7] !== _ || t[8] !== u ? (Z = u ?? ["all", ...Pr(n), ..._ ? xr(_) : []], t[6] = n, t[7] = _, t[8] = u, t[9] = Z) : Z = t[9];
  const H = y ?? z ?? "all";
  let $;
  t[10] !== N || t[11] !== V ? ($ = {
    collapseIcon: N,
    expandIcon: V
  }, t[10] = N, t[11] = V, t[12] = $) : $ = t[12];
  let q;
  t[13] !== a || t[14] !== A ? (q = (mt, at) => {
    const xt = at || "all";
    A && Yi({
      [A]: xt
    }), a && a(mt, xt);
  }, t[13] = a, t[14] = A, t[15] = q) : q = t[15];
  let Q;
  t[16] !== _ || t[17] !== m || t[18] !== A ? (Q = _ && /* @__PURE__ */ p(wr, { data: _, renderItem: m, urlParamKey: A }), t[16] = _, t[17] = m, t[18] = A, t[19] = Q) : Q = t[19];
  let S;
  t[20] !== n || t[21] !== l || t[22] !== L || t[23] !== s || t[24] !== $ || t[25] !== q || t[26] !== Q || t[27] !== Z || t[28] !== H ? (S = /* @__PURE__ */ O(Do, { defaultExpandedItems: Z, expandedItems: l, selectedItems: H, itemChildrenIndentation: L, expansionTrigger: "iconContainer", "aria-label": "product family navigator", slots: $, onExpandedItemsChange: s, onSelectedItemsChange: q, children: [
    Q,
    n
  ] }), t[20] = n, t[21] = l, t[22] = L, t[23] = s, t[24] = $, t[25] = q, t[26] = Q, t[27] = Z, t[28] = H, t[29] = S) : S = t[29];
  let Y;
  t[30] !== S || t[31] !== F ? (Y = /* @__PURE__ */ p(jn, { variant: "outlined", elevation: 0, sx: F, children: S }), t[30] = S, t[31] = F, t[32] = Y) : Y = t[32];
  let nt;
  return t[33] !== Y || t[34] !== o ? (nt = /* @__PURE__ */ p(ot, { container: !0, children: /* @__PURE__ */ O(ot, { size: J, children: [
    o,
    Y
  ] }) }), t[33] = Y, t[34] = o, t[35] = nt) : nt = t[35], nt;
}, wc = (e) => {
  const t = _e(15), {
    icon: n,
    id: i,
    label: r,
    style: o,
    sx: a,
    disabled: s,
    onClick: l,
    onContextMenu: u,
    children: f
  } = e;
  let P;
  t[0] !== l || t[1] !== u ? (P = (y) => {
    y.preventDefault(), l(), u?.(y);
  }, t[0] = l, t[1] = u, t[2] = P) : P = t[2];
  let _;
  t[3] !== r || t[4] !== l || t[5] !== o || t[6] !== a || t[7] !== P ? (_ = /* @__PURE__ */ p(St, { display: "flex", alignItems: "center", px: 0.75, py: 0.5, lineHeight: 1.2, style: o, sx: a, onClick: l, onContextMenu: P, children: r }), t[3] = r, t[4] = l, t[5] = o, t[6] = a, t[7] = P, t[8] = _) : _ = t[8];
  let m;
  return t[9] !== f || t[10] !== s || t[11] !== n || t[12] !== i || t[13] !== _ ? (m = /* @__PURE__ */ p(Eo, { itemId: i, disabled: s, icon: n, label: _, children: f }, i), t[9] = f, t[10] = s, t[11] = n, t[12] = i, t[13] = _, t[14] = m) : m = t[14], m;
};
_r.Leaf = wc;
function Pr(e) {
  const t = [];
  return Pn.Children.forEach(e, (n) => {
    if (Pn.isValidElement(n)) {
      const i = n.props, r = i.itemId ?? i.id;
      r && t.push(r), i.children && t.push(...Pr(i.children));
    }
  }), t;
}
function xr(e) {
  const t = [];
  return e.forEach((n) => {
    t.push(n.id), n.children && t.push(...xr(n.children));
  }), t;
}
function wr({
  data: e,
  renderItem: t,
  urlParamKey: n
}) {
  return e ? e.map((i) => /* @__PURE__ */ p(_r.Leaf, { id: i.id, disabled: i.disabled, label: t?.(i) ?? i.label, icon: i.icon, onClick: () => {
    n && Yi({
      [n]: i.id
    });
  }, children: i.children && /* @__PURE__ */ p(wr, { data: i.children, renderItem: t, urlParamKey: n }) }, i.id)) : null;
}
class sd extends Pn.Component {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError(t) {
    return {
      hasError: !0,
      error: t
    };
  }
  componentDidCatch(t, n) {
    console.log("render failed", t, n);
  }
  render() {
    if (this.state.hasError) {
      const {
        errorImageSrc: t = "images/wentWrong.png",
        homeHref: n = "/"
      } = this.props;
      return /* @__PURE__ */ O("div", { style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }, children: [
        t ? /* @__PURE__ */ p("img", { src: t, alt: "error" }) : null,
        /* @__PURE__ */ p(Lt, { variant: "h4", children: "Something went wrong." }),
        /* @__PURE__ */ p("br", {}),
        /* @__PURE__ */ p(zr, { severity: "error", children: this.state.error?.message ?? "Unknown error" }),
        /* @__PURE__ */ p(Lt, { variant: "caption", children: "Check developer console for more details." }),
        /* @__PURE__ */ p("br", {}),
        /* @__PURE__ */ p(vo, { variant: "contained", color: "primary", onClick: () => {
          window.location.href = n;
        }, children: "Go Back to Home" })
      ] });
    }
    return this.props.children;
  }
}
const yc = (e) => {
  const t = _e(257), {
    overlays: n,
    isFullscreen: i,
    overlayOpacity: r,
    onResetOverlay: o,
    onOpacityChange: a,
    onFullscreenToggle: s,
    onViewModeChange: l,
    onUpload: u,
    onPlanDelete: f,
    onSelectCustomPlan: P,
    onAddCustomPlan: _,
    onMapTypeChange: m,
    currentMapType: y
  } = e, w = Br(), g = n[0], [N, V] = Pn.useState(!1), L = !!g?.plan?.calibrationPoints?.floorPlan?.imageData, A = !!g?.plan?.calibrationPoints?.rfPlan?.imageData, T = !!g?.plan?.calibrationPoints?.sinrPlan?.imageData, z = !!g?.plan?.calibrationPoints?.dominantCellPlan?.imageData;
  let J;
  t[0] !== g?.plan?.calibrationPoints?.customPlan ? (J = g?.plan?.calibrationPoints?.customPlan || [], t[0] = g?.plan?.calibrationPoints?.customPlan, t[1] = J) : J = t[1];
  const F = J;
  let Z;
  t[2] !== g?.currentViewMode ? (Z = (j) => g?.currentViewMode === j, t[2] = g?.currentViewMode, t[3] = Z) : Z = t[3];
  const H = Z, [$, q] = Pn.useState(null), Q = !!$, S = g?.selectedCustomPlanName || F[0]?.planName;
  let Y;
  if (t[4] !== F || t[5] !== S) {
    let j;
    t[7] !== S ? (j = (An) => An.planName === S, t[7] = S, t[8] = j) : j = t[8], Y = F.find(j), t[4] = F, t[5] = S, t[6] = Y;
  } else
    Y = t[6];
  const nt = Y;
  let mt;
  t[9] !== g?.currentViewMode || t[10] !== g?.plan?.calibrationPoints?.dominantCellPlan?.imageName || t[11] !== g?.plan?.calibrationPoints?.floorPlan?.imageName || t[12] !== g?.plan?.calibrationPoints?.rfPlan?.imageName || t[13] !== g?.plan?.calibrationPoints?.sinrPlan?.imageName || t[14] !== nt?.imagesInfo?.imageName || t[15] !== S ? (mt = () => {
    switch (g?.currentViewMode) {
      case "FLOOR_PLAN":
        return g?.plan?.calibrationPoints?.floorPlan?.imageName;
      case "RF_PLAN":
        return g?.plan?.calibrationPoints?.rfPlan?.imageName;
      case "SINR_PLAN":
        return g?.plan?.calibrationPoints?.sinrPlan?.imageName;
      case "DOMINANT_CELL_PLAN":
        return g?.plan?.calibrationPoints?.dominantCellPlan?.imageName;
      case "CUSTOM_PLAN":
        return nt?.imagesInfo?.imageName || S;
      default:
        return;
    }
  }, t[9] = g?.currentViewMode, t[10] = g?.plan?.calibrationPoints?.dominantCellPlan?.imageName, t[11] = g?.plan?.calibrationPoints?.floorPlan?.imageName, t[12] = g?.plan?.calibrationPoints?.rfPlan?.imageName, t[13] = g?.plan?.calibrationPoints?.sinrPlan?.imageName, t[14] = nt?.imagesInfo?.imageName, t[15] = S, t[16] = mt) : mt = t[16];
  const at = mt;
  let xt;
  t[17] !== g?.currentViewMode || t[18] !== g?.plan?.calibrationPoints?.dominantCellPlan?.imageData || t[19] !== g?.plan?.calibrationPoints?.floorPlan?.imageData || t[20] !== g?.plan?.calibrationPoints?.rfPlan?.imageData || t[21] !== g?.plan?.calibrationPoints?.sinrPlan?.imageData || t[22] !== nt?.imagesInfo?.imageData ? (xt = () => {
    switch (g?.currentViewMode) {
      case "FLOOR_PLAN":
        return g?.plan?.calibrationPoints?.floorPlan?.imageData;
      case "RF_PLAN":
        return g?.plan?.calibrationPoints?.rfPlan?.imageData;
      case "SINR_PLAN":
        return g?.plan?.calibrationPoints?.sinrPlan?.imageData;
      case "DOMINANT_CELL_PLAN":
        return g?.plan?.calibrationPoints?.dominantCellPlan?.imageData;
      case "CUSTOM_PLAN":
        return nt?.imagesInfo?.imageData;
      default:
        return;
    }
  }, t[17] = g?.currentViewMode, t[18] = g?.plan?.calibrationPoints?.dominantCellPlan?.imageData, t[19] = g?.plan?.calibrationPoints?.floorPlan?.imageData, t[20] = g?.plan?.calibrationPoints?.rfPlan?.imageData, t[21] = g?.plan?.calibrationPoints?.sinrPlan?.imageData, t[22] = nt?.imagesInfo?.imageData, t[23] = xt) : xt = t[23];
  const Fe = xt;
  let Pe;
  t[24] !== Fe || t[25] !== at ? (Pe = () => {
    const j = at(), An = Fe();
    zo(An, j);
  }, t[24] = Fe, t[25] = at, t[26] = Pe) : Pe = t[26];
  const $e = Pe;
  let B;
  t[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = {
    mr: 1,
    height: "24px",
    fontSize: "12px"
  }, t[27] = B) : B = t[27];
  let ht;
  t[28] !== m ? (ht = () => m?.("ROADMAP"), t[28] = m, t[29] = ht) : ht = t[29];
  let xe;
  t[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xe = /* @__PURE__ */ p(uo, { fontSize: "small" }), t[30] = xe) : xe = t[30];
  let zt;
  t[31] !== ht ? (zt = /* @__PURE__ */ p(yt, { title: "Roadmap", children: /* @__PURE__ */ p(Jt, { value: "ROADMAP", onClick: ht, children: xe }) }), t[31] = ht, t[32] = zt) : zt = t[32];
  let jt;
  t[33] !== m ? (jt = () => m?.("HYBRID"), t[33] = m, t[34] = jt) : jt = t[34];
  let Ge;
  t[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ge = /* @__PURE__ */ p(fo, { fontSize: "small" }), t[35] = Ge) : Ge = t[35];
  let Bt;
  t[36] !== jt ? (Bt = /* @__PURE__ */ p(yt, { title: "Satellite", children: /* @__PURE__ */ p(Jt, { value: "HYBRID", onClick: jt, children: Ge }) }), t[36] = jt, t[37] = Bt) : Bt = t[37];
  let it;
  t[38] !== y || t[39] !== zt || t[40] !== Bt ? (it = /* @__PURE__ */ O(_i, { size: "small", exclusive: !0, sx: B, value: y, color: "primary", children: [
    zt,
    Bt
  ] }), t[38] = y, t[39] = zt, t[40] = Bt, t[41] = it) : it = t[41];
  const cn = g?.currentViewMode || null;
  let ct;
  t[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ct = {
    flexWrap: "wrap",
    justifyContent: "flex-start"
  }, t[42] = ct) : ct = t[42];
  let te;
  t[43] !== N || t[44] !== g?.currentViewMode || t[45] !== S || t[46] !== w ? (te = N && /* @__PURE__ */ p(Jt, { value: "TOGGLE_PLAN_TOGGLES_AC", sx: {
    ...U.planButton,
    ...U.planButtonActive(w)
  }, onClick: () => V(Nc), children: /* @__PURE__ */ p(yt, { title: `Current View: ${g?.currentViewMode === "CUSTOM_PLAN" ? S ?? "Custom Plan" : Hi()[g?.currentViewMode || "FLOOR_PLAN"].tooltip}`, children: To(g?.currentViewMode || "FLOOR_PLAN", {
    mr: 0.5
  }, {
    fontSize: "small"
  }) }) }), t[43] = N, t[44] = g?.currentViewMode, t[45] = S, t[46] = w, t[47] = te) : te = t[47];
  let gt;
  t[48] !== N ? (gt = N && {
    display: "none"
  }, t[48] = N, t[49] = gt) : gt = t[49];
  let I;
  t[50] !== L || t[51] !== H || t[52] !== w ? (I = L && H("FLOOR_PLAN") ? U.planButtonActive(w) : L ? U.planButtonInactive(w) : {}, t[50] = L, t[51] = H, t[52] = w, t[53] = I) : I = t[53];
  let et;
  t[54] !== gt || t[55] !== I ? (et = {
    ...U.planButton,
    ...gt,
    ...I
  }, t[54] = gt, t[55] = I, t[56] = et) : et = t[56];
  let ut;
  t[57] !== L || t[58] !== u || t[59] !== l ? (ut = () => L ? l("FLOOR_PLAN") : u("FLOOR_PLAN"), t[57] = L, t[58] = u, t[59] = l, t[60] = ut) : ut = t[60];
  let ft;
  t[61] !== L ? (ft = L ? /* @__PURE__ */ p(wi, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(nn, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[61] = L, t[62] = ft) : ft = t[62];
  let ke;
  t[63] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ke = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "Floor Plan" }), t[63] = ke) : ke = t[63];
  let Wt;
  t[64] !== et || t[65] !== ut || t[66] !== ft ? (Wt = /* @__PURE__ */ O(Jt, { value: "FLOOR_PLAN", sx: et, onClick: ut, children: [
    ft,
    ke
  ] }), t[64] = et, t[65] = ut, t[66] = ft, t[67] = Wt) : Wt = t[67];
  let ee;
  t[68] !== N ? (ee = N && {
    display: "none"
  }, t[68] = N, t[69] = ee) : ee = t[69];
  let we;
  t[70] !== A || t[71] !== H || t[72] !== w ? (we = A && H("RF_PLAN") ? U.planButtonActive(w) : A ? U.planButtonInactive(w) : {}, t[70] = A, t[71] = H, t[72] = w, t[73] = we) : we = t[73];
  let ye;
  t[74] !== ee || t[75] !== we ? (ye = {
    ...U.planButton,
    ...ee,
    ...we
  }, t[74] = ee, t[75] = we, t[76] = ye) : ye = t[76];
  let Nt;
  t[77] !== A || t[78] !== u || t[79] !== l ? (Nt = () => A ? l("RF_PLAN") : u("RF_PLAN"), t[77] = A, t[78] = u, t[79] = l, t[80] = Nt) : Nt = t[80];
  let It;
  t[81] !== A ? (It = A ? /* @__PURE__ */ p(io, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(nn, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[81] = A, t[82] = It) : It = t[82];
  let Ue;
  t[83] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ue = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "RF" }), t[83] = Ue) : Ue = t[83];
  let Ne;
  t[84] !== ye || t[85] !== Nt || t[86] !== It ? (Ne = /* @__PURE__ */ O(Jt, { value: "RF_PLAN", sx: ye, onClick: Nt, children: [
    It,
    Ue
  ] }), t[84] = ye, t[85] = Nt, t[86] = It, t[87] = Ne) : Ne = t[87];
  let be;
  t[88] !== N ? (be = N && {
    display: "none"
  }, t[88] = N, t[89] = be) : be = t[89];
  let Ht;
  t[90] !== T || t[91] !== H || t[92] !== w ? (Ht = T && H("SINR_PLAN") ? U.planButtonActive(w) : T ? U.planButtonInactive(w) : {}, t[90] = T, t[91] = H, t[92] = w, t[93] = Ht) : Ht = t[93];
  let ne;
  t[94] !== be || t[95] !== Ht ? (ne = {
    ...U.planButton,
    ...be,
    ...Ht
  }, t[94] = be, t[95] = Ht, t[96] = ne) : ne = t[96];
  let ie;
  t[97] !== T || t[98] !== u || t[99] !== l ? (ie = () => T ? l("SINR_PLAN") : u("SINR_PLAN"), t[97] = T, t[98] = u, t[99] = l, t[100] = ie) : ie = t[100];
  let ve;
  t[101] !== T ? (ve = T ? /* @__PURE__ */ p(ro, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(nn, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[101] = T, t[102] = ve) : ve = t[102];
  let re;
  t[103] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (re = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "SINR" }), t[103] = re) : re = t[103];
  let lt;
  t[104] !== ne || t[105] !== ie || t[106] !== ve ? (lt = /* @__PURE__ */ O(Jt, { value: "SINR_PLAN", sx: ne, onClick: ie, children: [
    ve,
    re
  ] }), t[104] = ne, t[105] = ie, t[106] = ve, t[107] = lt) : lt = t[107];
  let Yt;
  t[108] !== N ? (Yt = N && {
    display: "none"
  }, t[108] = N, t[109] = Yt) : Yt = t[109];
  let Tt;
  t[110] !== z || t[111] !== H || t[112] !== w ? (Tt = z && H("DOMINANT_CELL_PLAN") ? U.planButtonActive(w) : z ? U.planButtonInactive(w) : {}, t[110] = z, t[111] = H, t[112] = w, t[113] = Tt) : Tt = t[113];
  let Xt;
  t[114] !== Yt || t[115] !== Tt ? (Xt = {
    ...U.planButton,
    ...Yt,
    ...Tt
  }, t[114] = Yt, t[115] = Tt, t[116] = Xt) : Xt = t[116];
  let oe;
  t[117] !== z || t[118] !== u || t[119] !== l ? (oe = () => z ? l("DOMINANT_CELL_PLAN") : u("DOMINANT_CELL_PLAN"), t[117] = z, t[118] = u, t[119] = l, t[120] = oe) : oe = t[120];
  let Gt;
  t[121] !== z ? (Gt = z ? /* @__PURE__ */ p(oo, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(nn, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[121] = z, t[122] = Gt) : Gt = t[122];
  let qt;
  t[123] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (qt = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "Dominant Cell" }), t[123] = qt) : qt = t[123];
  let Ae;
  t[124] !== Xt || t[125] !== oe || t[126] !== Gt ? (Ae = /* @__PURE__ */ O(Jt, { value: "DOMINANT_CELL_PLAN", sx: Xt, onClick: oe, children: [
    Gt,
    qt
  ] }), t[124] = Xt, t[125] = oe, t[126] = Gt, t[127] = Ae) : Ae = t[127];
  let Dt;
  t[128] !== N ? (Dt = N && {
    display: "none"
  }, t[128] = N, t[129] = Dt) : Dt = t[129];
  let ae;
  t[130] !== F.length || t[131] !== g?.currentViewMode || t[132] !== w ? (ae = g?.currentViewMode === "CUSTOM_PLAN" ? U.planButtonActive(w) : F.length > 0 ? U.planButtonInactive(w) : {}, t[130] = F.length, t[131] = g?.currentViewMode, t[132] = w, t[133] = ae) : ae = t[133];
  let bt;
  t[134] !== Dt || t[135] !== ae ? (bt = {
    ...U.planButton,
    ...Dt,
    ...ae
  }, t[134] = Dt, t[135] = ae, t[136] = bt) : bt = t[136];
  let Ce;
  t[137] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ce = (j) => q(j.currentTarget), t[137] = Ce) : Ce = t[137];
  let At, Ve;
  t[138] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (At = /* @__PURE__ */ p(wi, { fontSize: "small", sx: {
    mr: 0.5,
    transform: "rotate(90deg)"
  } }), Ve = {
    ...U.buttonLabel
  }, t[138] = At, t[139] = Ve) : (At = t[138], Ve = t[139]);
  let Rt;
  t[140] !== g?.currentViewMode || t[141] !== S ? (Rt = g?.currentViewMode === "CUSTOM_PLAN" && S ? S.trim().slice(0, 12) + (S.length > 12 ? "..." : "") : "Custom Plan", t[140] = g?.currentViewMode, t[141] = S, t[142] = Rt) : Rt = t[142];
  let Ct;
  t[143] !== Rt ? (Ct = /* @__PURE__ */ p("span", { style: Ve, children: Rt }), t[143] = Rt, t[144] = Ct) : Ct = t[144];
  let Kt;
  t[145] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Kt = /* @__PURE__ */ p(Wi, { fontSize: "small", sx: {
    ml: 0.25
  } }), t[145] = Kt) : Kt = t[145];
  let D;
  t[146] !== bt || t[147] !== Ct ? (D = /* @__PURE__ */ O(Jt, { value: "CUSTOM_PLAN", sx: bt, onClick: Ce, children: [
    At,
    Ct,
    Kt
  ] }), t[146] = bt, t[147] = Ct, t[148] = D) : D = t[148];
  let pt;
  t[149] !== N ? (pt = N && {
    display: "none"
  }, t[149] = N, t[150] = pt) : pt = t[150];
  let le;
  t[151] !== pt ? (le = {
    ...U.planButton,
    ...pt,
    minWidth: "auto"
  }, t[151] = pt, t[152] = le) : le = t[152];
  let Le;
  t[153] !== _ ? (Le = () => _?.(), t[153] = _, t[154] = Le) : Le = t[154];
  let _t;
  t[155] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_t = /* @__PURE__ */ p(yt, { title: "Add Custom Plan", children: /* @__PURE__ */ p(nn, { fontSize: "small" }) }), t[155] = _t) : _t = t[155];
  let rt;
  t[156] !== le || t[157] !== Le ? (rt = /* @__PURE__ */ p(Jt, { value: "ADD_CUSTOM_PLAN_SHORTCUT", sx: le, onClick: Le, children: _t }), t[156] = le, t[157] = Le, t[158] = rt) : rt = t[158];
  let ze, Ie;
  t[159] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ze = {
    ...U.planButton,
    minWidth: "auto"
  }, Ie = () => V(bc), t[159] = ze, t[160] = Ie) : (ze = t[159], Ie = t[160]);
  const un = N ? "Expand plan toggles" : "Collapse plan toggles";
  let Oe;
  t[161] !== N ? (Oe = N ? /* @__PURE__ */ p(to, { fontSize: "small" }) : /* @__PURE__ */ p(eo, { fontSize: "small" }), t[161] = N, t[162] = Oe) : Oe = t[162];
  let Et;
  t[163] !== un || t[164] !== Oe ? (Et = /* @__PURE__ */ p(Jt, { value: "TOGGLE_PLAN_TOGGLES", sx: ze, onClick: Ie, children: /* @__PURE__ */ p(yt, { title: un, children: Oe }) }), t[163] = un, t[164] = Oe, t[165] = Et) : Et = t[165];
  let Me;
  t[166] !== cn || t[167] !== te || t[168] !== Wt || t[169] !== Ne || t[170] !== lt || t[171] !== Ae || t[172] !== D || t[173] !== rt || t[174] !== Et ? (Me = /* @__PURE__ */ O(_i, { color: "primary", exclusive: !0, size: "small", value: cn, sx: ct, "aria-label": "overlay view", children: [
    te,
    Wt,
    Ne,
    lt,
    Ae,
    D,
    rt,
    Et
  ] }), t[166] = cn, t[167] = te, t[168] = Wt, t[169] = Ne, t[170] = lt, t[171] = Ae, t[172] = D, t[173] = rt, t[174] = Et, t[175] = Me) : Me = t[175];
  let qe, Ke, Je, Ft;
  t[176] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (qe = () => q(null), Ke = {
    dense: !0
  }, Je = {
    sx: {
      maxWidth: 320,
      width: "auto"
    }
  }, Ft = {
    mt: 0.5,
    maxHeight: 700,
    overflowY: "auto"
  }, t[176] = qe, t[177] = Ke, t[178] = Je, t[179] = Ft) : (qe = t[176], Ke = t[177], Je = t[178], Ft = t[179]);
  let Se;
  t[180] !== F || t[181] !== P || t[182] !== l || t[183] !== g?.currentViewMode || t[184] !== S ? (Se = F.length > 0 ? F.map((j) => /* @__PURE__ */ p(gi, { onClick: () => {
    P?.(j.planName), l("CUSTOM_PLAN"), q(null);
  }, "aria-label": j.planName, selected: g?.currentViewMode === "CUSTOM_PLAN" && j.planName === S, disabled: g?.currentViewMode === "CUSTOM_PLAN" && j.planName === S, children: /* @__PURE__ */ p(yt, { title: j.planName, placement: "right", children: /* @__PURE__ */ p(Sn, { variant: "body2", noWrap: !0, sx: {
    maxWidth: 200,
    overflow: "hidden",
    textOverflow: "ellipsis"
  }, children: j.planName }) }) }, j.planName)) : null, t[180] = F, t[181] = P, t[182] = l, t[183] = g?.currentViewMode, t[184] = S, t[185] = Se) : Se = t[185];
  let Te;
  t[186] !== _ ? (Te = () => {
    q(null), _?.();
  }, t[186] = _, t[187] = Te) : Te = t[187];
  let Ze;
  t[188] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ze = /* @__PURE__ */ p(nn, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[188] = Ze) : Ze = t[188];
  let Qe;
  t[189] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Qe = /* @__PURE__ */ p(Sn, { variant: "body2", sx: {
    fontWeight: 500
  }, children: "Add Custom Plan" }), t[189] = Qe) : Qe = t[189];
  let De;
  t[190] !== Te ? (De = /* @__PURE__ */ O(gi, { onClick: Te, children: [
    Ze,
    Qe
  ] }), t[190] = Te, t[191] = De) : De = t[191];
  let se;
  t[192] !== $ || t[193] !== Q || t[194] !== Se || t[195] !== De ? (se = /* @__PURE__ */ O(Wr, { anchorEl: $, open: Q, onClose: qe, MenuListProps: Ke, PaperProps: Je, sx: Ft, children: [
    Se,
    De
  ] }), t[192] = $, t[193] = Q, t[194] = Se, t[195] = De, t[196] = se) : se = t[196];
  let ce;
  t[197] !== it || t[198] !== Me || t[199] !== se ? (ce = /* @__PURE__ */ O(St, { sx: U.menuColumn, children: [
    it,
    Me,
    se
  ] }), t[197] = it, t[198] = Me, t[199] = se, t[200] = ce) : ce = t[200];
  let ue;
  t[201] !== o || t[202] !== g || t[203] !== n.length ? (ue = n.length > 0 && /* @__PURE__ */ p(yt, { title: "Reset Overlay", children: /* @__PURE__ */ p(de, { onClick: () => g?.id && o(g.id), size: "small", children: /* @__PURE__ */ p(qr, { fontSize: "small" }) }) }), t[201] = o, t[202] = g, t[203] = n.length, t[204] = ue) : ue = t[204];
  let je;
  t[205] !== r ? (je = Math.round(r * 100), t[205] = r, t[206] = je) : je = t[206];
  const fn = `Increase Opacity (${je}%)`;
  let Ot;
  t[207] !== a || t[208] !== r ? (Ot = () => a(Math.min(1, r + 0.1)), t[207] = a, t[208] = r, t[209] = Ot) : Ot = t[209];
  const tn = r >= 1;
  let en;
  t[210] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (en = /* @__PURE__ */ p(xi, { fontSize: "small", sx: {
    transform: "rotate(180deg)"
  } }), t[210] = en) : en = t[210];
  let c;
  t[211] !== Ot || t[212] !== tn ? (c = /* @__PURE__ */ p(de, { onClick: Ot, size: "small", disabled: tn, children: en }), t[211] = Ot, t[212] = tn, t[213] = c) : c = t[213];
  let d;
  t[214] !== fn || t[215] !== c ? (d = /* @__PURE__ */ p(yt, { title: fn, children: c }), t[214] = fn, t[215] = c, t[216] = d) : d = t[216];
  let h;
  t[217] !== r ? (h = Math.round(r * 100), t[217] = r, t[218] = h) : h = t[218];
  const x = `Decrease Opacity (${h}%)`;
  let v;
  t[219] !== a || t[220] !== r ? (v = () => a(Math.max(0, r - 0.1)), t[219] = a, t[220] = r, t[221] = v) : v = t[221];
  const C = r <= 0;
  let b;
  t[222] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ p(xi, { fontSize: "small" }), t[222] = b) : b = t[222];
  let R;
  t[223] !== v || t[224] !== C ? (R = /* @__PURE__ */ p(de, { onClick: v, size: "small", disabled: C, children: b }), t[223] = v, t[224] = C, t[225] = R) : R = t[225];
  let X;
  t[226] !== x || t[227] !== R ? (X = /* @__PURE__ */ p(yt, { title: x, children: R }), t[226] = x, t[227] = R, t[228] = X) : X = t[228];
  const W = i ? "error" : "primary";
  let K;
  t[229] !== i ? (K = i ? /* @__PURE__ */ p(Jr, { fontSize: "small" }) : /* @__PURE__ */ p(Kr, { fontSize: "small" }), t[229] = i, t[230] = K) : K = t[230];
  let st;
  t[231] !== s || t[232] !== W || t[233] !== K ? (st = /* @__PURE__ */ p(yt, { title: "Toggle Fullscreen", children: /* @__PURE__ */ p(de, { onClick: s, size: "small", color: W, children: K }) }), t[231] = s, t[232] = W, t[233] = K, t[234] = st) : st = t[234];
  let E;
  t[235] !== ue || t[236] !== d || t[237] !== X || t[238] !== st ? (E = /* @__PURE__ */ O(St, { sx: U.controlsColumn, children: [
    ue,
    d,
    X,
    st
  ] }), t[235] = ue, t[236] = d, t[237] = X, t[238] = st, t[239] = E) : E = t[239];
  let k;
  t[240] !== ce || t[241] !== E ? (k = /* @__PURE__ */ p(St, { sx: U.container, children: /* @__PURE__ */ O(jn, { elevation: 2, sx: U.paper, children: [
    ce,
    E
  ] }) }), t[240] = ce, t[241] = E, t[242] = k) : k = t[242];
  let G;
  t[243] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = [U.container, U.planInfoContainer], t[243] = G) : G = t[243];
  let M;
  t[244] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = [U.paper, U.planPaper], t[244] = M) : M = t[244];
  let dt;
  t[245] !== at || t[246] !== $e || t[247] !== f || t[248] !== u || t[249] !== g || t[250] !== S ? (dt = at() && /* @__PURE__ */ p(St, { sx: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 1
  }, children: /* @__PURE__ */ O(St, { sx: U.planInfoRow, children: [
    /* @__PURE__ */ O(Sn, { variant: "body2", sx: U.fileName, title: at(), children: [
      /* @__PURE__ */ p("strong", { children: "Image:" }),
      " ",
      at()
    ] }),
    g?.currentViewMode === "CUSTOM_PLAN" ? /* @__PURE__ */ p(yt, { title: `Edit ${S || "Custom Plan"}`, children: /* @__PURE__ */ p(de, { size: "small", onClick: () => u("CUSTOM_PLAN"), children: /* @__PURE__ */ p(ao, { fontSize: "small" }) }) }) : /* @__PURE__ */ p(yt, { title: `Reupload ${g?.currentViewMode === "FLOOR_PLAN" ? "Floor Plan" : g?.currentViewMode === "RF_PLAN" ? "RF Plan" : g?.currentViewMode === "SINR_PLAN" ? "SINR Plan" : "Dominant Cell Plan"}`, children: /* @__PURE__ */ p(de, { size: "small", onClick: () => u(g?.currentViewMode || "RF_PLAN"), children: /* @__PURE__ */ p(so, { fontSize: "small" }) }) }),
    /* @__PURE__ */ p(yt, { title: "Download image", children: /* @__PURE__ */ p(de, { size: "small", onClick: $e, children: /* @__PURE__ */ p(co, { fontSize: "small" }) }) }),
    /* @__PURE__ */ p(yt, { title: "Delete image", children: /* @__PURE__ */ p(de, { size: "small", onClick: () => g?.currentViewMode && f?.(g.currentViewMode), children: /* @__PURE__ */ p(lo, { fontSize: "small" }) }) })
  ] }) }), t[245] = at, t[246] = $e, t[247] = f, t[248] = u, t[249] = g, t[250] = S, t[251] = dt) : dt = t[251];
  let tt;
  t[252] !== dt ? (tt = /* @__PURE__ */ p(St, { sx: G, children: /* @__PURE__ */ p(jn, { elevation: 2, sx: M, children: dt }) }), t[252] = dt, t[253] = tt) : tt = t[253];
  let $t;
  return t[254] !== tt || t[255] !== k ? ($t = /* @__PURE__ */ O("div", { style: U.mainContainer, children: [
    k,
    tt
  ] }), t[254] = tt, t[255] = k, t[256] = $t) : $t = t[256], $t;
};
function Nc(e) {
  return !e;
}
function bc(e) {
  return !e;
}
const vc = (e) => {
  const t = _e(51), {
    open: n,
    onClose: i,
    planInfo: r,
    customPlanName: o,
    onCustomPlanNameChange: a,
    onCustomPlanNameBlur: s,
    onFileSelect: l,
    onSubmit: u
  } = e, f = r.planType === "Custom";
  let P;
  t[0] !== r.dialogTitle || t[1] !== r.icon ? (P = /* @__PURE__ */ O(Hr, { sx: dn.uploadDialog.title, children: [
    r.icon,
    r.dialogTitle
  ] }), t[0] = r.dialogTitle, t[1] = r.icon, t[2] = P) : P = t[2];
  let _;
  if (t[3] !== r.planType) {
    let Y;
    t[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = /\s+/g, t[5] = Y) : Y = t[5], _ = r.planType.toLowerCase().replace(Y, "-"), t[3] = r.planType, t[4] = _;
  } else
    _ = t[4];
  const m = `${_}-plan-upload`;
  let y;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = {
    width: "fit-content"
  }, t[6] = y) : y = t[6];
  let w;
  t[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ p(Jn, { variant: "outlined", component: "span", startIcon: /* @__PURE__ */ p(no, {}), sx: {
    width: "100%"
  }, children: "Upload Image" }), t[7] = w) : w = t[7];
  let g;
  if (t[8] !== r.planType) {
    let Y;
    t[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = /\s+/g, t[10] = Y) : Y = t[10], g = r.planType.toLowerCase().replace(Y, "-"), t[8] = r.planType, t[9] = g;
  } else
    g = t[9];
  const N = `${g}-plan-upload`, V = `Upload ${r.planType} Plan Image`;
  let L;
  t[11] !== l || t[12] !== N || t[13] !== V ? (L = /* @__PURE__ */ p("input", { id: N, type: "file", hidden: !0, accept: "image/*", onChange: l, "aria-label": V }), t[11] = l, t[12] = N, t[13] = V, t[14] = L) : L = t[14];
  let A;
  t[15] !== m || t[16] !== L ? (A = /* @__PURE__ */ O("label", { htmlFor: m, style: y, children: [
    w,
    L
  ] }), t[15] = m, t[16] = L, t[17] = A) : A = t[17];
  let T;
  t[18] !== o || t[19] !== f || t[20] !== s || t[21] !== a || t[22] !== r.validation ? (T = f && /* @__PURE__ */ p(St, { sx: {
    mt: 2
  }, children: /* @__PURE__ */ p(Bo, { label: "Plan Name", value: o || "", onChange: (Y) => a(Y.target.value.slice(0, 40)), onBlur: s, placeholder: "Enter custom plan name", error: r.validation.showError, errorText: r.validation.showError ? r.validation.customPlanNameError : void 0, inputProps: {
    maxLength: 40
  }, height: 40 }) }), t[18] = o, t[19] = f, t[20] = s, t[21] = a, t[22] = r.validation, t[23] = T) : T = t[23];
  let z;
  t[24] !== r.currentFileData || t[25] !== r.displayImageName || t[26] !== r.displayPreviewUrl || t[27] !== r.planType ? (z = r.displayPreviewUrl && /* @__PURE__ */ O(an, { children: [
    /* @__PURE__ */ p(St, { sx: dn.uploadDialog.imagePreview, children: /* @__PURE__ */ p("img", { src: r.displayPreviewUrl, alt: `${r.planType} Plan Preview`, style: dn.uploadDialog.previewImage }) }),
    r.displayImageName && /* @__PURE__ */ p(yt, { title: r.currentFileData.previewUrl && r.currentFileData.imageSize > 0 ? `${r.displayImageName} (${yi(r.currentFileData.imageSize)})` : r.displayImageName, children: /* @__PURE__ */ O(Sn, { sx: dn.uploadDialog.fileInfo, children: [
      r.displayImageName,
      r.currentFileData.previewUrl && r.currentFileData.imageSize > 0 ? ` - ${yi(r.currentFileData.imageSize)}` : ""
    ] }) })
  ] }), t[24] = r.currentFileData, t[25] = r.displayImageName, t[26] = r.displayPreviewUrl, t[27] = r.planType, t[28] = z) : z = t[28];
  let J;
  t[29] !== A || t[30] !== T || t[31] !== z ? (J = /* @__PURE__ */ p(Yr, { children: /* @__PURE__ */ O(St, { sx: dn.uploadDialog.content, children: [
    A,
    T,
    z
  ] }) }), t[29] = A, t[30] = T, t[31] = z, t[32] = J) : J = t[32];
  let F;
  t[33] !== i ? (F = /* @__PURE__ */ p(Jn, { onClick: i, children: "Cancel" }), t[33] = i, t[34] = F) : F = t[34];
  const Z = f && !r.validation.isValid ? r.validation.customPlanNameError || "Please provide a valid plan name" : r.shouldDisableSubmit && !r.currentFileData.previewUrl ? "Please select an image to upload" : "", H = f && r.hasExistingData ? "Save" : "Upload";
  let $;
  t[35] !== u || t[36] !== r.shouldDisableSubmit || t[37] !== H ? ($ = /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(Jn, { onClick: u, variant: "contained", disabled: r.shouldDisableSubmit, children: H }) }), t[35] = u, t[36] = r.shouldDisableSubmit, t[37] = H, t[38] = $) : $ = t[38];
  let q;
  t[39] !== Z || t[40] !== $ ? (q = /* @__PURE__ */ p(yt, { title: Z, arrow: !0, children: $ }), t[39] = Z, t[40] = $, t[41] = q) : q = t[41];
  let Q;
  t[42] !== F || t[43] !== q ? (Q = /* @__PURE__ */ O(Xr, { children: [
    F,
    q
  ] }), t[42] = F, t[43] = q, t[44] = Q) : Q = t[44];
  let S;
  return t[45] !== i || t[46] !== n || t[47] !== P || t[48] !== J || t[49] !== Q ? (S = /* @__PURE__ */ O(Gr, { open: n, onClose: i, maxWidth: "sm", fullWidth: !0, children: [
    P,
    J,
    Q
  ] }), t[45] = i, t[46] = n, t[47] = P, t[48] = J, t[49] = Q, t[50] = S) : S = t[50], S;
}, Ac = Hi(Zr.planIcon), Cc = ({
  overlays: e,
  overlayTransformsRef: t,
  handleRotationChange: n,
  handleDragEnd: i,
  handleResize: r,
  resetCounter: o,
  enableEditingOverlay: a,
  activeOverlayId: s,
  overlayOpacity: l,
  visibilityZoomThreshold: u
}) => {
  const {
    mapRef: f
  } = Mr(), P = me(() => ({
    ...t.current
  }), [t]), _ = me(() => e.map((m) => {
    const y = P[m.id], w = m.plan?.calibrationPoints.floorPlan?.imageData, g = m.plan?.calibrationPoints.rfPlan?.imageData, N = m.plan?.calibrationPoints.sinrPlan?.imageData, V = m.plan?.calibrationPoints.dominantCellPlan?.imageData, L = m.selectedCustomPlanName, A = L ? m.plan?.calibrationPoints.customPlan?.find(($) => $.planName === L)?.imagesInfo?.imageData : void 0, T = a && m.id === s;
    let z = 0, J = 0, F = 0, Z = 0, H = 0;
    return T ? m.currentViewMode === "FLOOR_PLAN" ? (z = l, J = 0) : m.currentViewMode === "RF_PLAN" ? (z = 0, J = l) : m.currentViewMode === "SINR_PLAN" ? F = l : m.currentViewMode === "DOMINANT_CELL_PLAN" ? Z = l : m.currentViewMode === "CUSTOM_PLAN" && (H = l) : m.currentViewMode === "FLOOR_PLAN" ? z = l : m.currentViewMode === "RF_PLAN" ? J = l : m.currentViewMode === "SINR_PLAN" ? F = l : m.currentViewMode === "DOMINANT_CELL_PLAN" ? Z = l : m.currentViewMode === "CUSTOM_PLAN" && (H = l), /* @__PURE__ */ p(Mo, { id: m.id, rotation: y?.rotation || 0, setRotation: ($) => n($), map: f || null, floorPlanUrl: w, rfPlanUrl: g, sinrPlanUrl: N, dominantCellPlanUrl: V, customPlanUrl: A, floorPlanOpacity: z, rfPlanOpacity: J, sinrPlanOpacity: F, dominantCellPlanOpacity: Z, customPlanOpacity: H, skewX: y?.skewX || 0, skewY: y?.skewY || 0, onPositionChange: ($, q) => i(m.id, {
      lat: $,
      lng: q
    }), onBoundsChange: ($) => r(m.id, $), resetCounter: o, isActive: T, inactiveOpacity: l, bounds: y?.bounds || Tn(m.position, m), visibilityZoomThreshold: u }, m.id);
  }), [e, P, f, n, i, r, o, a, s, l, u]);
  return /* @__PURE__ */ p(an, { children: _ });
}, Lc = ({
  apiKey: e,
  center: t,
  zoom: n = 16,
  defaultOverlays: i = [],
  defaultOverlayPlan: r,
  enableEditingOverlay: o = !1,
  showMiniControls: a = !1,
  defaultMapType: s = "ROADMAP",
  onOverlaysUpdate: l,
  onTransformsUpdate: u,
  // childrenComponent,
  markers: f,
  onMarkerClick: P,
  onMarkerHover: _,
  onMarkerHoverLeave: m,
  selectedMarkerId: y,
  markerDraggable: w = !1,
  enableCluster: g = !1,
  getMapData: N,
  getMarkerData: V,
  defaultMapPins: L = [],
  onMapPinsUpdate: A,
  showAddressInput: T = !1,
  hideTooltip: z = !0,
  showMetaDataTooltip: J = !1,
  showCurrentLocation: F = !1,
  setMapType: Z,
  floorPlanIcon: H,
  rfPlanIcon: $,
  mapOptions: q,
  miniControlsMainStyles: Q,
  showFullscreenToggleOnMiniControls: S = !0,
  circles: Y = [],
  showCircles: nt = !1,
  showResetControl: mt = !1,
  visibilityZoomThreshold: at,
  // innerMapStyles,
  setShowCircles: xt,
  showCirclesControl: Fe = !1,
  overrideDrag: Pe = !1,
  defaultUpdatedOverlayImages: $e = null
}) => {
  const B = Mt({}), ht = Mt(!1), xe = Mt(null), zt = Mt(!1), jt = Mt(N);
  jt.current = N;
  const Ge = Mt(t), Bt = Mt(!1), [it, cn] = Pt($e), ct = wt((c) => {
    cn((d) => d ? d.includes(c) ? d : [...d, c] : [c]);
  }, []), te = Mt(u);
  te.current = u;
  const gt = me(() => Kn((c) => {
    te.current?.(c);
  }, Sr), []), [I, et] = Pt(() => i.map((c) => {
    let d;
    c.plan?.calibrationPoints.map?.center ? d = {
      lat: c.plan.calibrationPoints.map.center.latitude,
      lng: c.plan.calibrationPoints.map.center.longitude
    } : d = {
      lat: parseFloat(t?.lat?.toString() || "42.357884"),
      lng: parseFloat(t?.lng?.toString() || "-71.095962")
    };
    const h = {
      floor: !!c.plan?.calibrationPoints.floorPlan?.imageData,
      rf: !!c.plan?.calibrationPoints.rfPlan?.imageData,
      sinr: !!c.plan?.calibrationPoints.sinrPlan?.imageData,
      dom: !!c.plan?.calibrationPoints.dominantCellPlan?.imageData,
      custom: (c.plan?.calibrationPoints.customPlan || []).length > 0
    };
    let x = "RF_PLAN", v;
    if (r) {
      const R = r.trim();
      if (R === "FLOOR_PLAN" && h.floor) x = "FLOOR_PLAN";
      else if (R === "RF_PLAN" && h.rf) x = "RF_PLAN";
      else if (R === "SINR_PLAN" && h.sinr) x = "SINR_PLAN";
      else if (R === "DOMINANT_CELL_PLAN" && h.dom) x = "DOMINANT_CELL_PLAN";
      else if (R.startsWith("CUSTOM_PLAN:") && h.custom) {
        const X = R.split(":")[1], W = c.plan?.calibrationPoints.customPlan?.find((K) => K.imagesInfo?.imageId === X);
        W && (x = "CUSTOM_PLAN", v = W.planName);
      }
    }
    r || (h.rf ? x = "RF_PLAN" : h.floor ? x = "FLOOR_PLAN" : h.sinr ? x = "SINR_PLAN" : h.dom ? x = "DOMINANT_CELL_PLAN" : h.custom && (x = "CUSTOM_PLAN", v = c.plan?.calibrationPoints.customPlan?.[0]?.planName));
    const C = {
      points: [],
      heading: 0,
      center: {
        latitude: d.lat,
        longitude: d.lng
      }
    }, b = structuredClone(c);
    if (b.plan ? b.plan.calibrationPoints ? b.plan.calibrationPoints.map || (b.plan.calibrationPoints.map = C) : b.plan.calibrationPoints = {
      map: C
    } : b.plan = {
      calibrationPoints: {
        map: C
      }
    }, b.plan.calibrationPoints.map.points.length === 0) {
      const X = d.lat, W = d.lng, K = {
        latitude: X + 5e-4,
        longitude: W + 5e-4,
        id: "floorplan_northeast"
      }, st = {
        latitude: X - 5e-4,
        longitude: W - 5e-4,
        id: "floorplan_southwest"
      };
      b.plan.calibrationPoints.map.points = [K, st];
    }
    return {
      ...b,
      position: d,
      currentViewMode: x,
      ...v ? {
        selectedCustomPlanName: v
      } : {}
    };
  })), [ut, ft] = Pt(() => {
    if (!o) return null;
    const c = i.find((h) => h.plan?.calibrationPoints.floorPlan?.imageData);
    return (i.find((h) => h.plan?.calibrationPoints.rfPlan?.imageData) || c)?.id || null;
  }), ke = Mt(A);
  ke.current = A;
  const Wt = me(() => Kn((c) => {
    ke.current?.(c);
  }, Tr), []), [ee, we] = Pt(() => L.map((c) => ({
    ...c,
    location: {
      lat: 0,
      lng: 0
    }
    // Initial placeholder, will be calculated when overlay is ready
  }))), [ye, Nt] = Pt(0), [It, Ue] = Pt(!1), Ne = Mt(null), [be, Ht] = Pt(!1), [ne, ie] = Pt(null), [ve, re] = Pt(!1), [lt, Yt] = Pt(null), [Tt, Xt] = Pt([]), oe = i[0]?.plan?.calibrationPoints?.map?.opacity, Gt = oe !== void 0 ? oe : Dr, [qt, Ae] = Pt(Gt), [Dt, ae] = Pt(!1), {
    isLoaded: bt,
    loadError: Ce
  } = Lr({
    id: Ar,
    googleMapsApiKey: e,
    libraries: vr
  }), [At, Ve] = Pt(() => {
    const c = i[0];
    if (c?.plan?.calibrationPoints?.map?.center) {
      const d = c.plan.calibrationPoints.map.center;
      return {
        lat: d.latitude,
        lng: d.longitude,
        name: d.name
      };
    }
    return t;
  }), [Rt, Ct] = Pt(!1), Kt = Mt(!1), D = Oo(I, Ac, H, $);
  fe(() => {
    Bt.current = !0, t && !At && Ve(t);
  }, []), fe(() => {
    L.length > 0 && we(L);
  }, [L]), fe(() => {
    Bt.current && t && !ht.current && !Rt && (!At || Math.abs(At.lat - t.lat) > 1e-5 || Math.abs(At.lng - t.lng) > 1e-5) && Ve(t);
  }, [t, Rt, At]), fe(() => {
    if (!(!bt || !I.length)) {
      if (I.forEach((c) => {
        if (!B.current[c.id]) {
          const d = c.plan?.calibrationPoints?.map?.heading || 0, h = mn(c.position, Math.round(d));
          h.bounds = Tn(c.position, c), B.current[c.id] = h;
        }
      }), !ut && o) {
        const c = I[0];
        if (c && (ft(c.id), !B.current[c.id])) {
          const d = c.plan?.calibrationPoints?.map?.heading || 0, h = mn(c.position, Math.round(d));
          h.bounds = Tn(c.position, c), B.current[c.id] = h;
        }
      }
      gt({
        ...B.current
      }), Nt((c) => c + 1);
    }
  }, [bt, I, ut, o, gt]);
  const [pt, le] = Pt(s), Le = me(() => bt ? {
    controlSize: Rr,
    mapTypeControl: !o,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_LEFT,
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.HYBRID]
    },
    mapTypeId: pt.toLowerCase(),
    mapId: Cr,
    zoomControl: !0,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    streetViewControl: !1,
    fullscreenControl: !1,
    scaleControl: !1,
    rotateControl: !1,
    tilt: 0,
    gestureHandling: "greedy",
    disableDefaultUI: !1
  } : {}, [bt, pt, o]), _t = wt((c) => c.map((d) => {
    const h = B.current[d.id];
    if (!h) return null;
    const x = h.bounds;
    if (!x) return null;
    const v = {
      latitude: x.getNorthEast().lat(),
      longitude: x.getNorthEast().lng(),
      id: "floorplan_northeast"
    }, C = {
      latitude: x.getSouthWest().lat(),
      longitude: x.getSouthWest().lng(),
      id: "floorplan_southwest"
    }, b = d.plan?.calibrationPoints.map?.center, R = {
      points: [v, C],
      zoom: d.plan?.calibrationPoints.map?.zoom,
      center: b,
      heading: h.rotation,
      view: pt,
      opacity: qt
    };
    return {
      id: d.id,
      plan: {
        calibrationPoints: {
          floorPlan: d.plan?.calibrationPoints.floorPlan,
          rfPlan: d.plan?.calibrationPoints.rfPlan,
          sinrPlan: d.plan?.calibrationPoints.sinrPlan,
          dominantCellPlan: d.plan?.calibrationPoints.dominantCellPlan,
          customPlan: d.plan?.calibrationPoints.customPlan,
          map: R
        }
      }
    };
  }).filter((d) => d !== null), [pt, qt]), rt = me(() => {
    let c = null, d = null;
    return async (h, x, v) => {
      c && clearTimeout(c);
      const C = new Promise((b) => {
        c = setTimeout(async () => {
          try {
            l?.(h, v);
          } catch (R) {
            console.error("Error in notifyOverlaysUpdate:", R);
          } finally {
            b();
          }
        }, 1e3);
      });
      d = C, await C, C === d && (c = null, d = null);
    };
  }, [l]), ze = wt((c) => {
    zt.current || (zt.current = !0, o && (c.center && (Rt || (ht.current = !0, xe.current && clearTimeout(xe.current), xe.current = setTimeout(() => {
      setTimeout(() => {
        ht.current = !1;
      }, 3e3);
    }, 300))), et((d) => {
      const h = d.map((x) => {
        if (x.plan?.calibrationPoints?.map) {
          const v = {
            ...x
          };
          return v.plan && (v.plan = {
            ...v.plan,
            calibrationPoints: {
              ...v.plan.calibrationPoints,
              map: {
                ...v.plan.calibrationPoints.map,
                center: {
                  latitude: c.center.lat,
                  longitude: c.center.lng,
                  name: c?.address
                },
                view: pt,
                // Conditionally update zoom if available
                ...c.zoom ? {
                  zoom: c.zoom
                } : {}
              }
            }
          }), v;
        }
        return x;
      });
      return rt(_t(h), "mapData", it), h;
    })), jt.current?.(c), setTimeout(() => {
      zt.current = !1;
    }, 100));
  }, [Rt, o, pt, _t, rt, it]);
  fe(() => {
    if (f) {
      Xt(f);
      return;
    }
    if (!I?.length || !L?.length || !bt || !google.maps.geometry)
      return;
    const c = I[0];
    let d = B.current[c.id];
    if (!d || !d.bounds) {
      const x = c.plan?.calibrationPoints?.map?.heading || 0;
      if (d = mn(c.position, Math.round(x)), d.bounds = Tn(c.position, c), !d.bounds) {
        console.error("Failed to create initial bounds for marker conversion.");
        return;
      }
      B.current[c.id] = d;
    }
    const h = L.map((x) => {
      const v = Ni(
        x.floorPlan.xOffset,
        // Input is 0-1000
        x.floorPlan.yOffset,
        // Input is 0-1000
        d.bounds,
        d.rotation
      );
      return v ? {
        ...x,
        id: x.id,
        location: v,
        title: x.title,
        metadata: {
          ...x.metadata || {},
          xOffset: x.floorPlan.xOffset,
          yOffset: x.floorPlan.yOffset,
          editable: x.editable ?? !0
        }
      } : null;
    }).filter((x) => x !== null);
    Xt(h);
  }, [I, L, f, bt]);
  const Ie = wt((c) => {
    if (!I?.length || f) return;
    const d = I[0], h = B.current[d.id];
    if (!h?.bounds) return;
    const x = h.bounds, v = h.rotation, C = So(c.location.lat, c.location.lng, h);
    if (!C) return;
    const b = Math.max(0, Math.min(bi, C.xOffset)), R = Math.max(0, Math.min(bi, C.yOffset)), X = Ni(b, R, x, v);
    if (!X) return;
    const K = !Array.isArray(c.metadata) && c.metadata?.resetToMapCenter === !0 ? {
      lat: c.location.lat,
      lng: c.location.lng,
      address: c.location.address
    } : X, st = L.map((k) => k.id === c.id ? {
      ...k,
      floorPlan: {
        xOffset: b,
        yOffset: R
      },
      location: K
    } : k), E = Tt.map((k) => k.id === c.id ? {
      ...k,
      location: K
    } : k);
    Xt(E), Wt(st), V?.({
      ...c,
      location: K
    });
  }, [I, L, Tt, f, V, Wt]), un = wt((c) => {
    if (ze(c), Kt.current && c.markerLocation && y) {
      const d = {
        id: y,
        location: c.markerLocation
      };
      Ie(d);
    }
  }, [ze, y, Ie]), Oe = wt((c, d, h) => {
    const x = ee.find((v) => v.id === c.id);
    x && x.editable !== !1 && (Kt.current = !0), P?.(c, d, h);
  }, [ee, P]);
  fe(() => {
    const c = () => {
      Kt.current = !1;
    }, d = () => {
      Kt.current = !1;
    };
    return window.addEventListener("mouseup", c), window.addEventListener("mouseleave", d), () => {
      window.removeEventListener("mouseup", c), window.removeEventListener("mouseleave", d);
    };
  }, []), fe(() => {
    const c = i[0]?.plan?.calibrationPoints?.map?.view, d = _t(I);
    pt !== c && d.length > 0 && rt(d, "mapTypeChange", it);
  }, [pt]);
  const Et = me(() => (c) => {
    if (!c) return null;
    if (!B.current[c]) {
      const d = I.find((h) => h.id === c);
      if (!d) return null;
      B.current[c] = mn(d.position, d.plan?.calibrationPoints?.map?.heading || 0);
    }
    return B.current[c];
  }, [I]), Me = wt((c) => {
    if (!ut) return;
    Ct(!0), ht.current = !0;
    const d = B.current[ut];
    d && (d.rotation = Math.round(c), B.current[ut] = d, gt({
      ...B.current
    }), et((h) => {
      const x = h.map((v) => {
        if (v.id === ut && v.plan?.calibrationPoints?.map) {
          const C = {
            ...v
          };
          return C.plan && (C.plan = {
            ...C.plan,
            calibrationPoints: {
              ...C.plan.calibrationPoints,
              map: {
                ...C.plan.calibrationPoints.map,
                heading: Math.round(c)
              }
            }
          }), C;
        }
        return v;
      });
      return rt(_t(x), "rotationChange", it), x;
    }), Nt((h) => h + 1), setTimeout(() => {
      Ct(!1), setTimeout(() => {
        ht.current = !1;
      }, 3e3);
    }, 500));
  }, [ut, gt, rt, _t, it]), qe = wt((c, d) => {
    Ct(!0), ht.current = !0;
    const h = Et(c);
    h && (h.position = d, B.current[c] = h, gt({
      ...B.current
    }), et((x) => {
      const v = x.map((C) => {
        if (C.id === c && C.plan?.calibrationPoints?.map) {
          const b = {
            ...C
          };
          if (b.plan && (b.plan = {
            ...b.plan,
            calibrationPoints: {
              ...b.plan.calibrationPoints,
              map: {
                ...b.plan.calibrationPoints.map,
                // Update center while preserving its structure
                center: {
                  ...b.plan.calibrationPoints.map.center || {},
                  latitude: d.lat,
                  longitude: d.lng
                }
              }
            }
          }, h.bounds)) {
            const R = {
              latitude: h.bounds.getNorthEast().lat(),
              longitude: h.bounds.getNorthEast().lng(),
              id: "floorplan_northeast"
            }, X = {
              latitude: h.bounds.getSouthWest().lat(),
              longitude: h.bounds.getSouthWest().lng(),
              id: "floorplan_southwest"
            };
            b.plan.calibrationPoints.map.points = [R, X];
          }
          return b;
        }
        return C;
      });
      return rt(_t(v), "dragEnd", it), v;
    }), Nt((x) => x + 1), setTimeout(() => {
      Ct(!1), setTimeout(() => {
        ht.current = !1;
      }, 3e3);
    }, 500));
  }, [Et, gt, rt, _t, it]), Ke = wt((c, d) => {
    Ct(!0), ht.current = !0;
    const h = Et(c);
    h && (h.bounds = d, B.current[c] = h, gt({
      ...B.current
    }), et((x) => {
      const v = x.map((C) => {
        if (C.id === c && C.plan?.calibrationPoints?.map) {
          const b = {
            ...C
          };
          if (b.plan) {
            const R = {
              latitude: d.getNorthEast().lat(),
              longitude: d.getNorthEast().lng(),
              id: "floorplan_northeast"
            }, X = {
              latitude: d.getSouthWest().lat(),
              longitude: d.getSouthWest().lng(),
              id: "floorplan_southwest"
            }, W = d.getCenter(), K = W ? {
              latitude: W.lat(),
              longitude: W.lng(),
              ...b.plan.calibrationPoints.map.center ? {
                name: b.plan.calibrationPoints.map.center.name
              } : {}
            } : void 0;
            b.plan = {
              ...b.plan,
              calibrationPoints: {
                ...b.plan.calibrationPoints,
                map: {
                  ...b.plan.calibrationPoints.map,
                  points: [R, X],
                  ...K ? {
                    center: K
                  } : {}
                }
              }
            }, W && (h.position = {
              lat: W.lat(),
              lng: W.lng()
            }, B.current[c] = h);
          }
          return b;
        }
        return C;
      });
      return rt(_t(v), "resize", it), v;
    }), Nt((x) => x + 1), setTimeout(() => {
      Ct(!1), setTimeout(() => {
        ht.current = !1;
      }, 3e3);
    }, 500));
  }, [Et, gt, rt, _t, it]), Je = (c, d) => {
    c && (ft(c), et((h) => h.map((x) => x.id === c ? {
      ...x,
      currentViewMode: d
    } : x)), Nt((h) => h + 1));
  }, Ft = wt((c, d, h, x) => {
    const v = `overlay-${Date.now()}`, C = At || t || {
      lat: 0,
      lng: 0,
      address: ""
    }, b = {
      id: v,
      position: C,
      currentViewMode: h,
      plan: {
        calibrationPoints: {
          map: {
            points: [],
            heading: 0,
            center: {
              latitude: C.lat,
              longitude: C.lng,
              name: C.address
            }
          }
        }
      }
    };
    x || h === "FLOOR_PLAN" ? b.plan.calibrationPoints.floorPlan = {
      imageData: c,
      imageName: d
    } : h === "RF_PLAN" ? b.plan.calibrationPoints.rfPlan = {
      imageData: c,
      imageName: d
    } : h === "SINR_PLAN" ? b.plan.calibrationPoints.sinrPlan = {
      imageData: c,
      imageName: d
    } : h === "DOMINANT_CELL_PLAN" ? b.plan.calibrationPoints.dominantCellPlan = {
      imageData: c,
      imageName: d
    } : h === "CUSTOM_PLAN" && (b.plan.calibrationPoints.customPlan = [{
      planName: D.state.customPlanName || "Custom Plan",
      imagesInfo: {
        imageData: c,
        imageName: d
      }
    }], b.selectedCustomPlanName = D.state.customPlanName || "Custom Plan");
    const R = mn(C);
    if (bt) {
      const W = new google.maps.LatLngBounds(new google.maps.LatLng(C.lat - 5e-4, C.lng - 5e-4), new google.maps.LatLng(C.lat + 5e-4, C.lng + 5e-4));
      if (R.bounds = W, b.plan?.calibrationPoints?.map) {
        const K = {
          latitude: W.getNorthEast().lat(),
          longitude: W.getNorthEast().lng(),
          id: "floorplan_northeast"
        }, st = {
          latitude: W.getSouthWest().lat(),
          longitude: W.getSouthWest().lng(),
          id: "floorplan_southwest"
        };
        b.plan.calibrationPoints.map.points = [K, st];
      }
    }
    return B.current[v] = R, b;
  }, [At, t, bt, D.state.customPlanName]), Se = wt(() => {
    let c = [];
    const d = new Set(it || []), h = D.state.mode, x = D.state.editingOverlayId, v = D.state.floorPlan, C = D.state.rfPlan, b = D.state.sinrPlan, R = D.state.dominantCellPlan, X = D.state.customPlan, W = D.state.customPlanName, K = D.state.targetCustomPlanName, st = D.state.targetCustomPlanIndex;
    if (h === "ADD_FLOOR_PLAN") {
      if (!v.previewUrl) {
        alert("Please upload a floor plan image");
        return;
      }
      if (x)
        et((E) => {
          const k = E.map((G) => {
            if (G.id === x) {
              const M = G.plan?.calibrationPoints?.map?.center, dt = {
                ...G,
                // Shallow copy top-level properties
                plan: {
                  // Create a new plan object
                  ...G.plan || {},
                  // Copy properties from the old plan, or start with empty if no plan
                  calibrationPoints: {
                    // Create a new calibrationPoints object
                    ...G.plan?.calibrationPoints || {},
                    // Copy properties from old calPoints, or start with empty
                    map: G.plan?.calibrationPoints?.map || {
                      // Ensure map object exists, initialize if not
                      points: [],
                      heading: 0,
                      center: {
                        latitude: G.position.lat,
                        longitude: G.position.lng,
                        name: M?.name
                      }
                    }
                    // rfPlan will be carried over if it existed on overlay.plan.calibrationPoints
                    // floorPlan will be assigned below
                  }
                }
              };
              return dt.plan.calibrationPoints.floorPlan = {
                imageData: v.previewUrl,
                imageName: v.imageName
              }, dt.currentViewMode = "FLOOR_PLAN", dt;
            }
            return G;
          });
          return c = k, k;
        }), ft(x), ct("FLOOR_PLAN"), d.add("FLOOR_PLAN");
      else {
        const E = Ft(v.previewUrl, v.imageName, "FLOOR_PLAN", !0);
        et((k) => (c = [...k, E], c)), ft(E.id), ct("FLOOR_PLAN"), d.add("FLOOR_PLAN");
      }
    } else if (h === "ADD_RF_PLAN") {
      if (!C.previewUrl) {
        alert("Please upload an RF plan image");
        return;
      }
      if (!x && I.length === 0) {
        const E = Ft(C.previewUrl, C.imageName, "RF_PLAN", !1);
        et((k) => (c = [...k, E], c)), ft(E.id), ct("RF_PLAN"), d.add("RF_PLAN");
      } else {
        const E = x || I[0]?.id;
        if (!E) {
          alert("Error: No overlay available for editing");
          return;
        }
        et((k) => {
          const G = k.map((M) => {
            if (M.id === E) {
              const dt = M.plan?.calibrationPoints?.map?.center, tt = {
                ...M,
                // Shallow copy top-level properties
                plan: {
                  // Create a new plan object
                  ...M.plan || {},
                  // Copy properties from the old plan, or start with empty if no plan
                  calibrationPoints: {
                    // Create a new calibrationPoints object
                    ...M.plan?.calibrationPoints || {},
                    // Copy properties from old calPoints, or start with empty
                    map: M.plan?.calibrationPoints?.map || {
                      // Ensure map object exists, initialize if not
                      points: [],
                      heading: 0,
                      center: {
                        latitude: M.position.lat,
                        longitude: M.position.lng,
                        name: dt?.name
                      }
                    }
                    // floorPlan will be carried over if it existed on overlay.plan.calibrationPoints
                    // rfPlan will be assigned below
                  }
                }
              };
              return tt.plan.calibrationPoints.rfPlan = {
                imageData: C.previewUrl,
                imageName: C.imageName
              }, tt.currentViewMode = "RF_PLAN", tt;
            }
            return M;
          });
          return c = G, G;
        }), ft(E), ct("RF_PLAN"), d.add("RF_PLAN");
      }
    } else if (h === "ADD_SINR_PLAN") {
      if (!b.previewUrl) {
        alert("Please upload a SINR plan image");
        return;
      }
      if (!x && I.length === 0) {
        const E = Ft(b.previewUrl, b.imageName, "SINR_PLAN", !1);
        et((k) => (c = [...k, E], c)), ft(E.id);
      } else {
        const E = x || I[0]?.id;
        if (!E) {
          alert("Error: No overlay available for editing");
          return;
        }
        et((k) => {
          const G = k.map((M) => {
            if (M.id === E) {
              const dt = M.plan?.calibrationPoints?.map?.center, tt = {
                ...M,
                plan: {
                  ...M.plan || {},
                  calibrationPoints: {
                    ...M.plan?.calibrationPoints || {},
                    map: M.plan?.calibrationPoints?.map || {
                      points: [],
                      heading: 0,
                      center: {
                        latitude: M.position.lat,
                        longitude: M.position.lng,
                        name: dt?.name
                      }
                    }
                  }
                }
              };
              return tt.plan.calibrationPoints.sinrPlan = {
                imageData: b.previewUrl,
                imageName: b.imageName
              }, tt.currentViewMode = "SINR_PLAN", tt;
            }
            return M;
          });
          return c = G, G;
        }), ft(E);
      }
      ct("SINR_PLAN"), d.add("SINR_PLAN");
    } else if (h === "ADD_DOMINANT_CELL_PLAN") {
      if (!R.previewUrl) {
        alert("Please upload a Dominant Cell plan image");
        return;
      }
      const E = x || I[0]?.id;
      if (!E && I.length === 0) {
        const k = Ft(R.previewUrl, R.imageName, "DOMINANT_CELL_PLAN", !1);
        et((G) => (c = [...G, k], c)), ft(k.id);
      } else E && (et((k) => {
        const G = k.map((M) => {
          if (M.id === E) {
            const dt = M.plan?.calibrationPoints?.map?.center, tt = {
              ...M,
              plan: {
                ...M.plan || {},
                calibrationPoints: {
                  ...M.plan?.calibrationPoints || {},
                  map: M.plan?.calibrationPoints?.map || {
                    points: [],
                    heading: 0,
                    center: {
                      latitude: M.position.lat,
                      longitude: M.position.lng,
                      name: dt?.name
                    }
                  }
                }
              }
            };
            return tt.plan.calibrationPoints.dominantCellPlan = {
              imageData: R.previewUrl,
              imageName: R.imageName
            }, tt.currentViewMode = "DOMINANT_CELL_PLAN", tt;
          }
          return M;
        });
        return c = G, G;
      }), ft(E));
      ct("DOMINANT_CELL_PLAN"), d.add("DOMINANT_CELL_PLAN");
    } else if (h === "ADD_CUSTOM_PLAN") {
      const E = x || I[0]?.id;
      if (!E && I.length === 0) {
        if (!X.previewUrl) {
          alert("Please upload a Custom plan image");
          return;
        }
        const tt = Ft(X.previewUrl, X.imageName, "CUSTOM_PLAN", !1);
        tt.selectedCustomPlanName = W || "Custom Plan", et(($t) => (c = [...$t, tt], c)), ft(tt.id);
      } else E && (et((tt) => {
        const $t = tt.map((j) => {
          if (j.id === E) {
            const Yn = j.plan?.calibrationPoints?.customPlan || [], yr = W?.trim(), hi = st ?? Yn.findIndex((Re) => Re.planName === (K || "")), Nr = hi >= 0, pn = yr || K || "Custom Plan", Xn = Nr ? hi : Yn.findIndex((Re) => Re.planName === pn), Cn = [...Yn];
            if (Xn >= 0) {
              const Re = Cn[Xn], qn = {
                imageData: X.previewUrl || Re.imagesInfo?.imageData,
                imageName: X.imageName || Re.imagesInfo?.imageName,
                imageId: Re.imagesInfo?.imageId
              };
              Cn[Xn] = {
                planName: pn,
                imagesInfo: qn
              };
            } else {
              if (!X.previewUrl)
                return j;
              const qn = `new_custom_${pn.replace(/\s+/g, "_")}_${Date.now()}`;
              Cn.push({
                planName: pn,
                imagesInfo: {
                  imageData: X.previewUrl,
                  imageName: X.imageName,
                  imageId: qn
                }
              });
            }
            const br = {
              ...j,
              plan: {
                ...j.plan || {},
                calibrationPoints: {
                  ...j.plan?.calibrationPoints || {},
                  customPlan: Cn
                }
              },
              currentViewMode: "CUSTOM_PLAN",
              selectedCustomPlanName: pn
            }, Gn = B.current[j.id];
            return Gn && Gn.bounds && (B.current[j.id] = {
              ...Gn
            }), br;
          }
          return j;
        });
        return c = $t, $t;
      }), ft(E));
      const G = c.find((tt) => tt.id === (x || I[0]?.id))?.plan?.calibrationPoints?.customPlan || [];
      let M;
      typeof st == "number" && st >= 0 && G[st]?.imagesInfo?.imageId ? M = G[st].imagesInfo.imageId : M = G.find(($t) => $t.planName === (W || K || ""))?.imagesInfo?.imageId;
      const dt = M ? `CUSTOM_PLAN:${M}` : `CUSTOM_PLAN:${W?.trim() || K || "Custom Plan"}`;
      ct(dt), d.add(dt);
    }
    ht.current = !0, setTimeout(() => {
      ht.current = !1;
    }, 5e3), D.actions.closeDialog(), Nt((E) => E + 1), rt(_t(c), "createOverlay", Array.from(d)), gt({
      ...B.current
    });
  }, [D.state, D.actions, I, Ft, gt, rt, _t, ct, it]), Te = (c) => {
    ie(c), Ht(!0);
  }, Ze = (c) => {
    Yt(c), re(!0);
  }, Qe = () => {
    if (!ne) return;
    const c = I.find((v) => v.id === ne), d = c?.plan?.calibrationPoints?.floorPlan, h = c?.plan?.calibrationPoints?.rfPlan, x = new Set(it || []);
    et([]), d && (x.add("FLOOR_PLAN"), ct("FLOOR_PLAN")), h && (x.add("RF_PLAN"), ct("RF_PLAN")), rt([], "resetConfirm", Array.from(x)), Ht(!1), ie(null), Nt((v) => v + 1);
  }, De = wt(() => {
    if (!lt) return;
    const c = I.findIndex((K) => K.id === ut);
    if (c === -1 || !I[c]?.plan?.calibrationPoints) {
      re(!1), Yt(null);
      return;
    }
    const d = JSON.parse(JSON.stringify(I)), h = d[c], x = new Set(it || []);
    if (lt === "FLOOR_PLAN")
      h.plan.calibrationPoints.floorPlan = void 0, x.add("FLOOR_PLAN"), ct("FLOOR_PLAN");
    else if (lt === "RF_PLAN")
      h.plan.calibrationPoints.rfPlan = void 0, x.add("RF_PLAN"), ct("RF_PLAN");
    else if (lt === "SINR_PLAN")
      h.plan.calibrationPoints.sinrPlan = void 0, x.add("SINR_PLAN"), ct("SINR_PLAN");
    else if (lt === "DOMINANT_CELL_PLAN")
      h.plan.calibrationPoints.dominantCellPlan = void 0, x.add("DOMINANT_CELL_PLAN"), ct("DOMINANT_CELL_PLAN");
    else if (lt === "CUSTOM_PLAN") {
      const K = d[c].selectedCustomPlanName;
      if (K) {
        const st = h.plan.calibrationPoints.customPlan || [], E = st.find((M) => M.planName === K);
        h.plan.calibrationPoints.customPlan = st.filter((M) => M.planName !== K);
        const k = E?.imagesInfo?.imageId, G = k ? `CUSTOM_PLAN:${k}` : `CUSTOM_PLAN:${K}`;
        x.add(G), ct(G);
      }
    }
    const v = h.plan.calibrationPoints.floorPlan !== void 0, C = h.plan.calibrationPoints.rfPlan !== void 0, b = h.plan.calibrationPoints.sinrPlan !== void 0, R = h.plan.calibrationPoints.dominantCellPlan !== void 0, X = (h.plan.calibrationPoints.customPlan || []).length > 0;
    let W = d;
    !v && !C && !b && !R && !X ? W = [] : ((lt === "FLOOR_PLAN" && h.currentViewMode === "FLOOR_PLAN" || lt === "RF_PLAN" && h.currentViewMode === "RF_PLAN" || lt === "SINR_PLAN" && h.currentViewMode === "SINR_PLAN" || lt === "DOMINANT_CELL_PLAN" && h.currentViewMode === "DOMINANT_CELL_PLAN" || lt === "CUSTOM_PLAN" && h.currentViewMode === "CUSTOM_PLAN") && (v ? h.currentViewMode = "FLOOR_PLAN" : C ? h.currentViewMode = "RF_PLAN" : b ? h.currentViewMode = "SINR_PLAN" : R ? h.currentViewMode = "DOMINANT_CELL_PLAN" : X && (h.currentViewMode = "CUSTOM_PLAN", h.selectedCustomPlanName = h.plan.calibrationPoints.customPlan?.[0]?.planName)), W = d), et(W), rt(W, "deletePlanConfirm", Array.from(x)), re(!1), Yt(null);
  }, [lt, I, ut, rt, ct, it]), se = wt((c) => {
    Ue((d) => !d), c.currentTarget.blur();
  }, []);
  fe(() => {
    const c = (d) => {
      d.key === "Escape" && It && Ue(!1);
    };
    return document.addEventListener("keydown", c), () => {
      document.removeEventListener("keydown", c);
    };
  }, [It]);
  const ce = Mt(pt);
  ce.current = pt;
  const ue = me(() => Kn((c) => {
    const d = c?.toUpperCase();
    !d || d === ce.current || le(d);
  }, Er), []);
  fe(() => () => {
    Wt.cancel(), ue.cancel(), gt.cancel();
  }, []);
  const je = wt((c, d) => {
    const h = d === "FLOOR_PLAN" ? "ADD_FLOOR_PLAN" : d === "RF_PLAN" ? "ADD_RF_PLAN" : d === "SINR_PLAN" ? "ADD_SINR_PLAN" : d === "DOMINANT_CELL_PLAN" ? "ADD_DOMINANT_CELL_PLAN" : "ADD_CUSTOM_PLAN";
    if (d === "CUSTOM_PLAN" && c) {
      const x = I.find((R) => R.id === c), v = x?.selectedCustomPlanName || null, C = x?.plan?.calibrationPoints?.customPlan || [], b = v ? C.findIndex((R) => R.planName === v) : -1;
      b >= 0 ? D.actions.openDialog(h, c, {
        targetName: v,
        targetIndex: b,
        targetImageId: C[b]?.imagesInfo?.imageId || null
      }) : D.actions.openDialog(h, c);
    } else
      D.actions.openDialog(h, c);
  }, [I, D.actions]), fn = wt(() => {
    D.actions.openDialog("ADD_CUSTOM_PLAN", I[0]?.id || null);
  }, [I, D.actions]), Ot = wt((c) => {
    const d = Number(Number(c.toFixed(2)));
    if (!isNaN(d)) {
      Ae(d);
      const h = _t(I);
      rt(h, "opacityChange", it);
    }
  }, [_t, I, rt, it]), tn = (c) => {
    I.length > 0 && (Dt && (Ot(Gt), ae(!1)), Je(I[0].id, c));
  }, en = () => {
    Ot(Dt ? Gt : 0), ae(!Dt);
  };
  return Ce ? (console.log(Ce), /* @__PURE__ */ O("div", { children: [
    "There was an error loading the Google Maps API",
    /* @__PURE__ */ p("p", { children: Ce.message })
  ] })) : /* @__PURE__ */ O(an, { children: [
    /* @__PURE__ */ p(Co, { open: be, onClose: () => Ht(!1), onConfirm: Qe }),
    /* @__PURE__ */ p(Ao, { open: ve, onClose: () => re(!1), onConfirm: De, planToDelete: lt || void 0, customPlanName: lt === "CUSTOM_PLAN" ? I.find((c) => c.id === ut)?.selectedCustomPlanName : void 0 }),
    /* @__PURE__ */ p(vc, { open: D.state.isOpen, onClose: D.actions.closeDialog, planInfo: D.planInfo, customPlanName: D.state.customPlanName, onCustomPlanNameChange: D.actions.setCustomPlanName, onCustomPlanNameBlur: D.actions.markCustomPlanNameTouched, onFileSelect: (c) => {
      const d = D.state.mode, h = d === "ADD_FLOOR_PLAN" ? D.handlers.floorPlan : d === "ADD_RF_PLAN" ? D.handlers.rfPlan : d === "ADD_SINR_PLAN" ? D.handlers.sinrPlan : d === "ADD_DOMINANT_CELL_PLAN" ? D.handlers.dominantCellPlan : D.handlers.customPlan;
      Lo(h)(c);
    }, onSubmit: Se }),
    /* @__PURE__ */ O("div", { ref: Ne, style: It ? Pi.fullscreen : Pi.normal, children: [
      !o && a && /* @__PURE__ */ p(Fr, { currentViewMode: I[0]?.currentViewMode || "FLOOR_PLAN", isOverlayHidden: Dt, overlayOpacity: qt, hasFloorPlan: !!I[0]?.plan?.calibrationPoints?.floorPlan?.imageData, hasRFPlan: !!I[0]?.plan?.calibrationPoints?.rfPlan?.imageData, onViewModeChange: tn, onOverlayVisibilityToggle: en, onOpacityChange: Ot, miniControlsMainStyles: Q, onFullscreenToggle: se, isFullscreen: It, showFullscreenToggle: S, showCirclesControl: Fe, setShowCircles: xt, showCircles: nt, hasOverlays: I.length > 0 }),
      o && /* @__PURE__ */ p(yc, { overlays: I, activeOverlayId: ut, overlayOpacity: qt, isFullscreen: It, onResetOverlay: Te, onOpacityChange: Ot, onFullscreenToggle: se, onViewModeChange: tn, onUpload: (c) => je(I[0]?.id || null, c), onPlanDelete: Ze, onSelectCustomPlan: (c) => {
        et((d) => d.map((h) => h.id === I[0]?.id ? {
          ...h,
          selectedCustomPlanName: c,
          currentViewMode: "CUSTOM_PLAN"
        } : h)), Nt((d) => d + 1);
      }, onAddCustomPlan: fn, onMapTypeChange: (c) => {
        le(c), Z?.(c);
      }, currentMapType: pt }),
      /* @__PURE__ */ p(
        Or,
        {
          apiKey: e,
          center: Bt.current ? At : Ge.current,
          zoom: n,
          mapType: pt.toUpperCase(),
          markers: Tt,
          options: {
            ...Le,
            ...q,
            gestureHandling: Kt.current ? "none" : "auto"
            // Prevent map movement during drag
          },
          width: "100%",
          height: "100%",
          onMarkerClick: Oe,
          onMarkerHover: _,
          onMarkerHoverLeave: m,
          selectedID: y?.toString(),
          hideTooltip: z,
          showMetaDataTooltip: J,
          setMapType: (c) => {
            ue(c), Z && Z(c);
          },
          markerDraggable: w,
          enableCluster: g,
          showAddressInput: T,
          showCurrentLocation: F,
          circles: nt ? Y : [],
          showCircles: nt,
          showResetControl: mt,
          getMapData: un,
          doNotGenerateAddress: !o && (!Tt.length || !w),
          overrideDrag: Pe,
          getMarkerData: f ? V : Ie,
          children: /* @__PURE__ */ p(Cc, { overlays: I, overlayTransformsRef: B, handleRotationChange: Me, handleDragEnd: qe, handleResize: Ke, resetCounter: ye, enableEditingOverlay: o, activeOverlayId: ut, overlayOpacity: qt, visibilityZoomThreshold: at })
        },
        `${r ?? "none"}-${i[0]?.id ?? "none"}`
      )
    ] })
  ] });
}, cd = Ir(Lc);
export {
  yc as C,
  sd as E,
  Bo as I,
  cd as M,
  Lc as O,
  Ut as S,
  _r as T,
  vc as U,
  ld as W,
  na as a,
  ta as b,
  Jo as c,
  Go as d,
  Xi as e,
  rn as f,
  ms as g,
  ad as i,
  $l as r
};
